const de = {
	"401": {
		"oops": "mies!",
		"noAuth": "Sie haben keine Berechtigung zum Zugriff auf diese Seite",
		"goback": "Vorherige Seite",
		"gohome": "Startseite"
	},
	"404": {
		"notFound": "Seite nicht gefunden"
	},
	"version": {
		"to_old": "Vorherige Version zurückkehr",
		"to_new": "Neue Version",
		"default_node": "Standard-Knoten",
		"default_theme": "Standardthema",
		"custom_theme": "Benutzerdefiniertes Thema"
	},
	"intro": {
		"sys_msg": "Systemnachricht",
		"gaa_msg": "Alarm-Erinnerung",
		"new_guide": "Anleitung für Einsteiger",
		"slider_quite": "zurücktreten aus Führung",
		"slider_pre": "Vorheriger Schritt",
		"slider_next": "Nächster Schritt",
		"slider_enter": "Eingabe der neuen Version",
		"step_project_1": "Verwaltungsgeräte des neuen Systems",
		"step_project_2": "Neu hinzugekommen",
		"step_project_3": "Projektverwaltung",
		"step_project_4": "Funktion, Verwaltung der Ausrüstung nach Posten. Die Benutzer können das Projekt ändern",
		"step_project_5": "neubauen, bearbeiten, löschen",
		"step_mode_1": "Auswählen mage Listeform für Anlagen",
		"step_mode_2": "Die Geräteliste kann durch bestätigt.",
		"step_mode_3": "Liste oder Karte",
		"step_mode_4": "Darstellung der Form. Sie können die Darstellungsmethode entsprechend Ihrer Situation wählen.",
		"step_device_1": "Schnelles Auffinden die Geräten nach Interesse",
		"step_device_2": "Neu hinzugekommen",
		"step_device_3": "Aufmerksamkeit an Geräte",
		"step_device_4": "Funktion，",
		"step_device_5": "Maus schweben",
		"step_device_6": "Während Sie sich auf dem Gerät bedienen, können Sie auf \"Verfolgen\" klicken，",
		"step_device_7": "Nach Aufmerksamkeit",
		"step_device_8": "Gerät kaqnn in diesem Projekt verwendet werden ",
		"step_device_9": "Topping",
		"step_device_10": "，Das ist einfach, um die Geräte zu finden, für die Sie sich interessieren.",
		"step_operate_1": "Übersichtlicheres Layout von Geräteinformationen",
		"step_operate_2": "Nachdem Sie das gewünschte Gerät ausgewählt haben, können Sie schnell das Energieflussdiagramm, die Geräteinformationen, das Datendiagramm, die Parameteranalyse, die Datenauflistung und die Alarminformationen des Geräts umsehen."
	},
	// 忘记账号
	"retrieveUser": {
		'forgetUser': 'Konto vergessen',
		'illustrate': 'Wenn Sie Ihr Konto vergessen haben, können Sie Kontoinformationen anfordern, indem Sie die PN-Nummer eines beliebigen Geräts unter Ihrem Konto eingeben, was Ihnen hilft, Ihr Konto zurückzurufen!',
		'pn': 'Bitte geben Sie die PN eines beliebigen Geräts unter Ihrem Konto ein',
		'comfig': 'Bestätigen',
		'Return_to_login': 'Zurück zum Login',
		'accountInfo': 'Kontoinformationen',
		'user': 'Ihr Benutzername ist',
		'phone': 'Die Telefonnummer, die an Ihr Konto gebunden ist, ist',
		'email': 'Die E-Mail, die mit Ihrem Konto verknüpft ist, ist',
		'pleasePn': 'Bitte geben Sie das Gerät PN ein',
		'pnError': 'Die eingegebene PN ist falsch',
		'pnErrorMsg': 'Datensammler nicht gefunden',
	},
	"plantCode": {
		"codeApplication": "Erlebenscode beantragen",
		"haveDevice": "Wenn Sie ein Gerät vorhanden, melden Sie sich nach der Registrierung an, um es zu benutzen",
		"goRegister": "Zur Registrierung kommen",
		"useDemo": "Noch kein Einladungscode？Der Einladungscode ist nur zur Demonstration",
		"applyNow": "Jetzt beantragen",
		"code_is_required": "Der Erlebenscode soll nicht leer.",
		"pleaseCode": "Bitte geben Sie den Einladungscode ein",
		"pleaseName": "Bitte geben Sie Ihren Name ein",
		"PleaseCompanyName": "Bitte geben Sie den Name Ihres Unternehmens ein",
		"PleaseCompanyAddress": "Bitte geben Sie Ihre Firmaanschrift ein",
		"PleaseNumber": "Bitte geben Sie Ihre Kontakttelefonnummer ein",
		"PleaseEmail": "Bitte geben Sie Ihre E-Mail Adresse ein",
		"PleaseApplication": "Bitte beschreiben Sie den Grund für Ihre Bewerbung",
		"reasonNotEmpty": "Der Grund für Ihre Bewerbung darf nicht leer sein",
		"successfulApplication": "Wenn Ihre Bewerbung erfolgreich ist, behalten Sie bitte Ihr Mobiltelefon oder Ihre E-Mail-Adresse im Auge. Wir werden uns so schnell wie möglich Sie antworten."
	},
	"login": {
		"login": "Anmeldung",
		"loginSuc": "Anmeldung erfolgreich",
		"no_account_yet": "Sie haben noch kein Konto?",
		"remember_pwd": "Erinnern Sie sich an Ihr Passwort",
		"no_invitation": "Haben Sie noch keinen Erlebenscode? Bitte Sie uns kontaktieren ",
		"linkman": "Yibang Sonnenlicht",
		"signup": "sofort registrieren",
		"usr": "Benutzername",
		"pwd": "Kennwort",
		"sample_station": "Demostration",
		"invitation": "Erlebenscode",
		"invitationLogin": "Erfahrungscode Anmeldung",
		"forgotPwd": "PasswortVergessen?",
		'forgotUser': 'KontoVergessen',
		"usrformat": "Kontoformat (2<=Benutzerlänge<=32)'.",
		"pwdformat": "Passwortformat (6<=Passwortlänge<=32)",
		"YHLogin": "Benutzer-Login",
		"Yzcode": "Bitte geben Sie den Bestätigungscode ein",
		"code": "Schieben Sie den Schieberegler unten, um das Rätsel zu vervollständigen",
		"Swipe_right": "Streichen Sie nach rechts",
		"scan_login": "Wischen Sie den Code, um sich anzumelden",
		"open": "öffnen",
		"Scancode_login": "Streichen Sie zum Einloggen",
		"scanning": "scannen",
		"success": "Erfolgreich ",
		"Pleaseconfirm_login": "Bitte bestätigen Sie Ihre Anmeldung",
		"SmartESS": "Optischer-Speicher",
		"pv123": "PV123 ESS",
		'X_Tech': 'X-Tech',
		"app_download": "APP herunterladen",
		"scan_download": "Handy-Scancode zum Herunterladen der APP",
		"YZcode_format": "Falsches Format des CAPTCHA, bitte geben Sie die Nummer ein",
		"no_validitycode": "Einladungscode ist nicht gültig",
		"auto_login": "Automatisches Anmelden",
	},
	"signup": {
		"login": "sofort anmelden",
		"code": "6-stelliger Verifizierungscode",
		"pwd": "6 - 32 Zeichen (Zahlen, Buchstaben, Unterstriche), Groß- und Kleinschreibung beachten",
		"confirm_password": "Bitte geben Sie Ihr Passwort erneut ein",
		"phone": "Mobiles Telefon",
		"phone_form": "innenhalb 32 Zeichen, bitte genau ausfüllen, um Ihr Passwort zu erhalten",
		"pn": "14 oder 18 Zeichen (nur Ziffern, Buchstaben)",
		"usr": "2-32 Zeichen (nur Chinesisch, Buchstaben, Unterstriche) Kontoname",
		"email": "Mailbox",
		"email_form": "innenhalb 64 Zeichen, bitte genau ausfüllen, um Ihr Passwort abzurufen",
		"existing_account": "ein Konto bereits haben?",
		"Register_account": "Registrieren Sie Ihr Konto",
		"signup": "Registrieren",
		"emailSignup": "E-Mail-Registrierung",
		"phoneSignup": "Mobile Registrierung",
		"registered": "Registrieren",
		"success": "Registrierung erfolgreich",
		"mobileformat": "Falsches Format der Handynummer (6-32)",
		"mobileformat1": "Bitte geben Sie die richtige Handynummer ein",
		"emailformat": "Bitte geben Sie die richtige E-Mail Adresse ein",
		"usrformat": "Falsches Format der Kontonummer, 2-32 (nur Chinesisch, Buchstaben, Unterstriche)",
		"pwdformat": "Falsches Passwortformat, 6-32 (nur Zahlen, Buchstaben, Unterstriche können verwendet werden)'",
		"pnformat": "Falsches Format der PN-Nummer, 14 oder 18 Ziffern (nur Ziffern, Buchstaben)",
		"qiang": "Starke",
		"zhong": "Mittel",
		"di": "Schwach",
		"qiangdu": "Passwortstärke:",
		"Byte_1": "Getippt",
		"Byte_2": "Zeichen",
		"usr_pl": "Benutzername",
		"pwd_pl": "Kennwort",
		"confirm_pl": "Bitte geben Sie Ihr Passwort erneut ein",
		"confirm_Pwdpl": "das Passwort bestätigen",
		"email_pl": "E-Mail Adresse",
		"mobile_pl": "Handynummer",
		"code_pl": "Verifizierungs-Code",
		"PN_pl": "PN-Nummer",
		"too_simple": "Das Passwort ist zu einfach, bitte geben Sie es erneut ein",
		"country_pl": "Land oder Region",
	},
	"createPlant": {
		"imageLimit": "Bilder werden nur im jpg- oder png-Format unterstützt und dürfen eine Größe von 8M nicht überschreiten.",
		"fileExceed": "Die Datei ist zu groß",
		"uploadSuccess": "Upload erfolgreich",
		"basic_settings": "Grundeinstellungen",
		"Standard_setting": "Standard-Einstellungen",
		"System_settings": "System-Einstellungen",
		"Solar_settings": "Solar-Einstellungen",
		"Grid_settings": "Netz-Einstellungen",
		"Battery_settings": "Batterie-Einstellungen",
		"Battery_settingsTT": "Allgemeine Batterieeinstellungen",
		"Battery_settings1": "Batteriemodul 1",
		"Battery_settings2": "Batteriemodul 2",
		"Work_settings2": "Systembetriebsstatus einstellen",
		"Machine_settings2": "Maschinenbereitschaft aktivieren",
		"Clear_settings2": "Fehler löschen",
		"Control_settings": "Einstellungen für Energiespeichermaschinen",
		"Load_setting": "Einstellungen der Last",
		"other_settings": "Sonstige Einstellungen",
		"Basic_setting": "Grundeinstellungen",
		"Advanced_setting": "Erweiterte Einstellungen",
		"select_all": "Alle auswählen",
		"pv": "PV",
		"gd": "Netz",
		"bt": "Batterie",
		"bc": "Last",
		"sy": "System",
		"eg": "Generator",
		"hl": "Haushaltslast"
	},
	"Upload": {
		"Upload": "Upload"
	},
	"menu": {
		"home": "Startseite",
		"datalogger": "Verwaltung des Zifferblocks(PN)",
		"account": "Kontoverwaltung",
		"device": "Ausrüstung",
		"overview": "Übersicht",
		"alarm": "Alarm",
		"setting": "System",
		"personal": "Persönliche Informationen",
		"basic": "Grundlegende Informationen",
		"password": "Passwort ändern",
		"alarmSetting": "Alarm-Einstellungen",
		"email": "E-Mail-Einstellungen",
		"mobile": "Einstellungen für das Mobiltelefon",
		"recharge": "Aufladen Einstellungen",
		"pay": "Aufladen",
		"record": "Aufzeichnung",
		"rate": "Tarif-Einstellungen",
		"customize": "Benutzerdefinierte Einstellungen",
		'firmware': 'Standard Upgrade Firmware',
		'firmwarenew': 'Firmware-Verwaltung',
		"adaptiveFirmware": "Adaptive Firmware",
		"Total_user": "Benutzer insgesamt：",
		"intelligenceUpgrade": "Intelligentes Upgrade",
		"intelligenceUpgradeTitle": "Kein Upgrade-Paket verfügbar, bitte kontaktieren Sie den Hersteller",
		"intelligenceUpgradeTitle1": "Bitte bestätigen Sie, ob das Gerät ein intelligentes Upgrade durchführen soll?",
		"intelligenceUpgradeTitle2": "Kein passendes Upgrade-Paket gefunden",
		"myDevice": "Mein Gerät",
		'strategy': 'Lokale Modernisierungsstrategie',
		'cloudsUpgrade': 'Cloud Upgrade',
		"functionalApplication": "Funktionelle Anwendungen",
		'browseAccount': 'Unterkontenverwaltung',

		"log": "Datenlogger-Protokoll",
		"actionLog": "Betriebsprotokoll",
		"Manufacturer": "Herstellermanagement",
		"datalogger_list": "Liste der Datensammler",
		"manufacturer_account": "Konto des Herstellers",
		"manufacturer_code": "Herstellercode",
		"protocol_binding": "Protokollbindung zur Datenerfassung",
		"type_code": "Typcode der Datenerfassungseinrichtung",
		"protocol_change": "Änderung des Datenerfassungsprotokolls",
		"AIP_Interface": "API Schnittstelle",
		"protocol_operation": "Protokoll-Operationswerkzeug",
		"recharge_management": "Verwaltung der Aufladung",
		"device_management": "Geräteverwaltung",
		"KEY_List": "Schlüsselliste",
		"Protocol_instruction": "Verwaltung von Protokollanweisungen",
		"Raw_data": "Analyse von Rohdaten",
		"Recharge_remedy": "Wiederaufladungsmittel",
		"device_function": "Funktion des Gerätemanagements",
		"Password_maintenance": "Passwortpflege für Steuerelement",
	},
	"header": {
		"plant_owner": "Kraftwerkseigentümer",
		"personal_infor": "Persönliche Informationen",
		"change_password": "Passwort ändern",
		"bind_mobile": "Mobiltelefon verbunden",
		"bind_email": "E-Mail verbunden",
		"language": "Einstellung der Sprache",
		"log_out": "Aus dem System abmelden",
		"skin": "Skin wechseln",
		"shopping_mall": "Einkaufszentrum",
		'operating_manual': 'Manuell',
		"pleaseSelect": "Bitte auswählen",
		"pleaseSelect1": "Bitte Zeit wählen",
		"pnAndAlias": "Nummernpicker PN-Nummer / Nummernpickername",
		"pnAndSN": "PN / SN"
	},
	"role": {
		"plantOwnerNew": "Gemeinsamer Benutzer",
		"plantOwner": "Kraftwerkseigentümer",
		"manufacturer": "Kontonummer des Herstellers",
		"distributor": "Vertriebshändler",
		"group": "Gruppe Kontonummer",
		"viewer": "Kraftwerk Viewer",
		"all": "Alle"
	},
	"statistic": {
		"All": "Alle",
		"regiontotal": "Gesamtzahl der Bereiche",
		"deviceStatus": "Status der Ausrüstung",
		"regionPercent": "Anteil der Region",
		"userActivity": "Benutzeraktivitätsrate",
		"dataUpdateTime": "Aktualisiert",
		"normal": "Normal",
		"offline": "Offline",
		"Allstate": "Alle Status",
		"warning": "Warnung",
		"fault": "Störung",
		"standby": "Standby",
		"totalDevice": "Alle Geräte",
		"allDevice": "Gesamtzahl der Geräte",
		"totalRegion": "Alle Bereiche",
		"other": "Andere",
		"allAccount": "Alle Benutzer",
		"generalAccount": "Eigentümer Benutzer",
		"adminAccount": "Händler Benutzer",
		"active": "Aktiv",
		"inactive": "Inaktiv",
		"pv": "Daten der Photovoltaik-Platte",
		"gd": "Stromnetzdaten",
		"sy": "Gerätedaten",
		"bt": "Batterie-Daten",
		"bc": "Lastdaten"
	},
	"account": {
		"title_pwd": "Bitte geben Sie das richtige Passwort ein",
		"title_pwd1": "Please enter a 6-32 bit password",
		"title_pwd2": "Bitte geben Sie das neue Passwort erneut ein",
		"title_mobile": "Bitte geben Sie eine 11-stellige Telefonnummer ein",
		"title_edit": "Bitte geben Sie die zu bearbeitenden Informationen ein",
		"title_info": "Bitte geben Sie die korrekte E-Mail-Adresse ein",
		"title_info1": "Bitte geben Sie die richtige Telefonnummer ein",
		"allAccount": "Alle Benutzer",
		"userAccount": "Benutzer",
		"groupAccount": "Gruppierung",
		"uselists": "Liste der Benutzerverwaltung",
		"accountManage": "Kontoverwaltung",
		"groupManage": "Verwaltung der Gruppen",
		"activeStatus": "Aktivitätsebene",
		"accountGroup": "Benutzergruppen",
		"createAccount": "Ein Konto erstellen",
		"relatedOwner": "Eigentümer der Partner",
		"relatedSuccess": "Partner erfolgreich",
		"adminRelated": "Bitte wählen Sie einen Administrator",
		"role": "Benutzertyp",
		"role1": "Benutzertyp：",
		"selectUserType": "Bitte wählen Sie einen Benutzertyp",
		"generalAccount": "Allgemeines Konto",
		"manageAccount": "Administrator-Konto",
		"accountName": "Benutzername",
		"accountName1": "Benutzername",
		"accountName2": "Bitte Benutzernamen eingeben",
		"accountRole": "Rolle",
		"nickname": "Benutzer Spitzname",
		"nickname1": "Benutzer Spitzname：",
		"password": "Benutzer-Passwort",
		"password1": "Benutzer-Passwort：",
		"newPwd": "Neues Passwort",
		"newPwd1": "Neues Passwort：",
		"confirmpassword": "das Passwort bestätigen",
		"confirmpassword1": "das Passwort bestätigen：",
		"createTime": "Erstellungszeit",
		"accountStatus": "Status des Benutzers",
		"dataloggerNum": "Anzahl der Nummerspicks PN",
		"deviceNum": "Anzahl der Geräte",
		"projectNum": "Anzahl der Projekt",
		"lastLogin": "Letzte Anmeldung",
		"editUser": "Benutzer bearbeiten",
		"editAccount": "Konto bearbeiten",
		"group": "Gruppierung",
		"group1": "Gruppierung：",
		"groupto": "Gruppierung nach",
		"changeGroup": "Gruppierung verschieben nach",
		"chooseGroup": "Bitte wählen Sie eine Gruppe",
		"changeGroupSuc": "Gruppierung verschieben erfolgreich",
		"defaultGroup": "Standard-Gruppierung",
		"enable": "Aktivieren",
		"disable": "Deaktivieren",
		"confirmDisable": "Sind Sie sicher, dass Sie diesen Benutzer deaktivieren?",
		"afterDisable": "Nach der Deaktivierung des Kontos,wird nicht mehr anmelden und den Inhalt des Kontos nicht mehr anzeigen oder ändern.",
		"disableSuc": "Deaktivierung erfolgreich",
		"confirmEnable": "Dieser Benutzer wird wieder aktivieren?",
		"deleteUser": "das Konto wird gelöscht",
		"afterEnable": "Nach der Aktivierung des Konto kann wieder angemeldet werden und der Inhalt des Kontos kann eingesehen oder geändert",
		"confirmDelete": "Sicherlich das Konto gelöscht wird?",
		"notRecovered": "Die Löschung wird nicht wiederhergestellt",
		"deleteSuc": "Gelöscht erfolgreich",
		"resetPwd": "Passwort zurücksetzen",
		"allTypeUser": "Alle Arten von Benutzern",
		"powerStationOwner": "Besitzer der Station",
		"powerStationViewer": "Kraftwerk Viewer",
		"admin": "Verwalter",
		"riyueyuan_lineSonAdmin": "Unteradministrator Produktionslinie",
		"riyueyuan_SonAdmin": "Unteradministrator",
		"nodata": "Zur Zeit sind keine Daten verfügbar",
		"reason": "Der Grund dafür, dass das Diagramm nicht angezeigt wird, kann sein：",
		"reason1": "Keine Daten für das Gerät verfügbar",
		"reason2": "in der Gerätvereinbarung steht keine Parameterfelder für erzeugte、 verbrauchte、 gekaufte、 verkaufte、 geladene、 entladene Leistung ",
		"reason3": "in Grätvereinbarung steht keine Parameterfelder für Stromerzeugung, Lastleistung, Batterieleistung, Netzleistung",
		"createSuc": "Kontoerstellung erfolgreich",
		"resetPwdSuc": "Passwort zurücksetzen erfolgreich",
		"allGroup": "Alle Gruppierung",
		"unclassified": "Keine Gruppierung",
		"cannotRedirect": "Dieses Konto ist kein Energiespeicherkonto und kann nicht angesprungen werden",
		"newPwdEmpty": "Neues Passwort kann nicht leer sein, bitte ausfüllen!",
		"accountList": "Liste der Konto",
		"mobile": "Mobiles Telefon",
		"mobile1": "Mobiles Telefon：",
		"email": "Mailbox",
		"email1": "Mailbox：",
		"modifiedsuccess": "Änderung von Benutzerinformationen ist erfolgreich!",
		"enablesuccess": "Aktiviert erfolgreich!",
		"disablesuccess": "Deaktivierung erfolgreich!",
		"groupsuccess": "Gruppierungsvorgang erfolgreich!",
		"pwdresetsuccess": "Passwort zurücksetzen erfolgreich!",
		"Deletesuccessfully": "Löschung des Kontos erfolgreich!",
		"plantOwner": "Kraftwerkseigentümer",
		"distributor": "Vertriebshändler",
		"operate": "Betrieb",
		"Edit": "Bearbeiten",
		"Delete": "Löschen",
		"binding": "Binden",
		"ascription": "Zugehörigkeit",
		"ascriptionSuccess": "Erfolgreich gehören",
		"ascription_result": "Attributionsergebnis",
		"cancel": "Abbrechen",
		"finish": "Erledigung",
		"confirm": "Bestätigung",
		"submit": "Absenden",
		"deletegroupsuccess": "Auszug aus der Gruppierung erfolgreich!",
		"deletegroup": "Aus der Gruppierung ausziehen",
		"currentTotal": "Aktuelle Summe",
		"projects": "Artikel",
		"searchPro": "Artikel suchen",
		"devices": "Geräte",
		"accounts": "Benutzer",
		"placeholder": "Suche nach einem Benutzernamen/einer Handynummer",
		"placeholder1": "Bitte geben Sie Ihren Benutzernamen/ Handynummer ein",
		"lastLoginTs": "Letzte Anmeldezeit",
		"enterHome": "Zur Startseite gehen",
		"ownedDevices": "Eigene Ausrüstung",
		"Distribution_collector": "Kollektoren verteilen",
		"tooltipContent": "Der Administrator kann alle Kollektoren unter einem Auftrag einem Unterverteiler zuordnen, indem er die Auftragsnummer verwendet",
		"Distribution_method": "Methode der Verteilung",
		"Batch_allocation": "Stapelverteilung",
		"Individual_allocation": "Individuelle Zuordnung",
		"Order_allocation": "Auftragszuordnung",
		"PNNum": "PN-Nummer",
		"order_number": "Nummer der Bestellung",
		"Allocation_result": "Ergebnis der Zuteilung",
		"Assigned_successfully": "Zuteilung erfolgreich",
		"order_check": "Prüfen Sie",
		"Confirm_assignment": "Bestätigung der Zuordnung zu",
		"IsIt": "Ist es",
		"limitFormat": "Es kann nur Dateien im Format \"xlsx\" und \"xls\" hochgeladen werden",
		"Ple_orderNum": "Bitte geben Sie Ihre Auftragsnummer ein",
		'Ple_orderNum1': 'Bitte geben Sie die korrekte Bestellnummer ein',
		'Ple_orderNum2': 'Dieser Befehl hat',
		'Ple_orderNum3': 'sammler, Zuteilung bestätigen an',
		'err_orderNum': 'In der Reihenfolge',
		'err_orderNum1': 'bitte bestätigen Sie, dass die in der Bestellung angegebenen Sammler nicht gebunden sind.',
		"dataogger_swith": "Datenerfassungsgerät hinzufügen",
		"dataogger_swithTip": "Kann dieses Konto die Berechtigung haben, Datensammler hinzuzufügen",
		"account_number": "Kontonummer",
		"Role_authority": "Zuständigkeit",
		"authority_Management": "Berechtigungsverwaltung",
		"Related_roles": "Verwandte Rollen",
		"Ple_role1": "Bitte wählen Sie die zugehörige Rolle aus",
		"Ple_role2": "Bitte geben Sie den Rollennamen/die ID ein",
		"Add_role": "Rolle hinzufügen",
		"Edit_role": "Rolle bearbeiten",
		"Role_id": "Rollen-ID",
		"Role_name": "Rollenname",
		"Ple_role3": "Bitte geben Sie den Rollennamen ein",
		"Role_des": "Rollenbeschreibung",
		"Ple_role4": "Bitte geben Sie eine Rollenbeschreibung ein",
		"module": "Modular",
		"First_page": "Seite",
		"Secondary_page": "Sekundärseite",
		"Function_points": "Funktion",
		"Remove_role": "Rolle löschen",
		"Ple_role5": "Bitte überprüfen Sie die Kontoberechtigungen",
		"No_permission_prompt": "Keine Berechtigung, bitte kontaktieren Sie den übergeordneten Administrator",
		"Ple_role6": "Der Rollenname existiert bereits, bitte erneut eingeben",
		"limit_UserTypeNum": "Bei Überschreiten des Limits existiert dieser Kontotyp bereits",
		"limit_UserTypeDataPermission": "Dealer-Konten können keine Rollen mit ausgewählten Datenberechtigungen verbinden.",
		"edit_limit_UserTypeDataPermission": "Die Rolle ist mit einem Händlerkonto verknüpft und die Datenberechtigungen können nicht bearbeitet werden.",
		"dataPermission": "Datenberechtigung",
		"functionalPermission": "Funktionsberechtigung"
	},
	"group": {
		"Create_groups": "Eine Gruppe erstellen",
		"Edit_groups": "Gruppierung bearbeiten",
		"Groups_list": "Liste der Gruppierung",
		"Group_name": "Name der Gruppierung",
		"Group_name1": "Name der Gruppierung：",
		"userCount": "Anzahl der Benutzer in der Gruppierung",
		"note": "Anmerkungen zur Gruppierung",
		"note1": "Anmerkungen zur Gruppierung：",
		"Operate": "Betrieb",
		"Delete": "Löschen",
		"cancel": "Abbrechen",
		"finish": "Erledigung",
		"confirm": "Bestätigung",
		"deletegroup": "Gruppe löschen",
		"deleteConfirm": "ob sicher, diese Gruppe gelöscht wird?",
		"entername": "Bitte geben Sie einen Gruppennamen ein",
		"deletesuc": "Löschen einer Gruppe ist erfolgreich",
		"creatsuc": "Gruppe erfolgreich erstellen",
		"editsuc": "Gruppe erfolgreich bearbeiten"
	},
	"device": {
		'set': 'Einrichten',
		"ownerShip": "Eigentümerwechsel",
    "oldOwner": "Vorheriger Eigentümer:",
    "nweOwner": "Neuer Eigentümer:",
    "loading": "Wird geladen...",
    "moreLoading": "Mehr durch Scrollen laden",
		'pleaseDate': 'Bitte wählen Sie ein Datum',
		'noDate': 'Ein zukünftiges Datum kann nicht ausgewählt werden',
		'deviceDebug': 'Fehlersuche',
		'upgradeType': 'Upgrade-Methode:',
		'defaultUpgrade': 'Standardupgrade',
		'cloudUpgrade': 'Cloud Upgrade',
		'continueUpgrade': 'Fortsetzung des Upgrades',
		'continueUpgradeSuccess': 'Erfolgreich aufgerüstet und hinzugefügt',
		'step': 'Startschritte:',
		'firmware_step_message': 'Bitte geben Sie die Schritte ein',
		'numberRlues': 'Bitte geben Sie die korrekte Anzahl der Schritte ein',
		'firmware_package_message': 'Bitte Firmware auswählen',
		'firmware_type_message': 'Bitte wählen Sie einen Typ',
		'baudrate_message': 'Bitte wählen Sie Baud',
		'device_continueUpgrade': 'Ausrüstung wird weiter modernisiert',
		'read': 'Lesen',
		'distribute': 'Verteilen',
		"optionTitle": "Ausgewählt",
		"optionTitle1": "Begriff",
		"optionTitle2": "Die Auswahl der Geräteparameter darf 4 nicht überschreiten",
		"optionTitle4": "Die Auswahl der Geräteparameter darf 12 nicht überschreiten",
		"optionTitle3": "Bitte wählen Sie keine Optionen mit mehr als zwei verschiedenen Einheiten",
		"upBatchDeviceTip": "Hinweis: Das Batch-Upgrade dient dazu, dieselbe Geräte-Firmware für mehrere Geräte zu aktualisieren. Bitte wählen Sie daher sorgfältig aus, wenn Sie nicht sicher sind, welche Firmware für Ihr Gerät geeignet ist!",
		"upSuccessDevice": "Gerät erfolgreich upgegradet",
		"upFailDevice": "Fehlgeschlagene Geräte",
		"brandDevice": "Geräte",
		"brand0": "Andere Energiespeichergeräte",
		"brand1": "Netzunabhängige Wechselrichter",
		"brand2": "Wechselrichter",
		"brand3": "Energiespeicher-All-in-One-Geräte",
		"Allthemachines": "Alle Geräte",
		"deviceList": "Liste der Geräte",
		'device': 'Geräte',
		'datalogger': 'Datensammler',
		"dataloggerList": "Liste der Nummerspicks PN",
		"followList": "Aufmerksamkeit an Geräte",
		"proList": "Projekt-Liste",
		"pro": "Projekt",
		"deviceName": "Name des Geräts",
		"dataview": "Echtzeit-Parameter",
		"dataTips": "Aktuelles Gerät ist offline, keine Echtzeitdaten.",
		"overview": "Statistische Übersicht",
		"chart": "Daten-Grafiken",
		"analysis": "Parameter-Analyse",
		"clause": "Auflistung der Daten",
		"Current_data": "Aktuelle Daten",
		"chosenParam": "Ausgewählte Parameter",
		"optionalParam": "Wählbare Parameter",
		"reset": "Zurücksetzen",
		"energyFlow": "Energieflussdiagramm",
		"device_name": "Name des Geräts",
		"device_pn": "PN-Nummer",
		"device_sn": "Gerät SN",
		"device_status": "Status der Ausrüstung",
		"device_upgrade1": "Letzter Aktualisierungsdatensatz Protokoll",
		"device_upgradeFirmware": "Wählen ein Firmware-Paket zur Aktualisierung des Geräts",
		"device_upgradeTime": "Zeitpunkt der Aktualisierung",
		"device_upgradeName": "Name der Upgrade-Firmware",
		"device_upgradeStatus": "Upgrade-Status",
		"device_upgradeProgress": "Fortschritt des Upgrades",
		"device_type": "Gerätetyp",
		"device_code": "Kommunikationsvereinbarung",
		"device_code_form": "Kommunikationsvereinbarung：",
		"device_model": "Gerätemodell",
		"User_belong": "yugehöriger Benutzer",
		"field": "Feldsteuerung",
		"Datalogger_belong": "Zugehöriger Nummerspicks PN",
		"detail": "Details anzeigen",
		"pageSize": "Aktuelle Seite anzeigen",
		"follow": "Verfolgen",
		"unfollow": "Unverfolgen",
		"report": "Berichte",
		"timeSlot": "Zeitspanne",
		"datalogger_pn": "Numerischer Picker PN",
		"coll_alias": "ein andere Name von PN",
		"device_address": "Gerät Adresse",
		"generation": "Photovoltaische Paneele",
		"grid": "Stromnetzdaten",
		"inverter": "Wechselrichter",
		"battery": "Batterie",
		"consumption": "Last",
		"relay": "Mikro-Wechselrichter",
		"alternator": "Stromerzeuger/Generator",
		"familyLoad": "Hauslast",
		"solar": "Solar",
		"cur_today": "Heute",
		"cur_thismonth": "Diesen Monat",
		"cur_thisyear": "In diesem Jahr",
		"cur_day": "Tag",
		"cur_month": "Monat",
		"cur_year": "Jahr",
		"day": "Leistung in Echtzeit",
		"month": "Leistung des aktuellen Monats",
		"year": "Leistung im laufenden Jahr",
		"all": "Gesamtstromleistung",
		"pvPower": "Erzeugte Leistung",
		"gridPower": "Stromnetz Leistung",
		"batteryPower": "Batterieleistung",
		"loadPower": "Leistung der Last",
		"generated": "Erzeugte Leistung",
		"charged": "Ladeleistung",
		"discharged": "Entladungsleistung",
		"sold": "Verkaufen von Strom",
		"bought": "Stromleistuing kaufen",
		"used": "Elektrizitätsverbrauch",
		"normal": "Normal",
		"offline": "Offline",
		"warning": "Warnung",
		"fault": "Störung",
		"standby": "Standby",
		"universal_firmware": "Universal-Firmware",
		"communication_firmware": "Firmware der Kommunikationsversion",
		"control_firmware1": "Steuerung-Firmware 1",
		"control_firmware2": "Steuerung-Firmware 2",
		"control_firmware_bms": "BMS-Firmware",
		"control_firmware_slavmcu": "SlavMCU-Firmware",
		"default": "Voreinstellung",
		"modifySuc": "Modifikation erfolgreich",
		"instruction_response": "Befehl wird gesendet, warte auf Antwort...",
		"debug_suc": "Debugging erfolgreich",
		"Debugfail": "Debugging fehlgeschlagen, Gerät ist offline",
		"Send_suc": "Befehl erfolgreich gesendet",
		"Send_Input": "Bitte geben Sie den Wert der zu sendenden Operation ein",
		"Send_fail": "Befehl konnte nicht gesendet werden",
		"fileExceed": "Die Datei ist zu groß",
		"uploadSuccess": "Upload erfolgreich",
		"error1": "Es können nur Dateien im \".bin\" und \".hex\" Format hochgeladen werden",
		"file_fist": "Bitte wählen Sie zuerst die zu aktualisierende Firmware aus",
		"updatefail": "Upgrade fehlgeschlagen, Kollektor ist möglicherweise offline, oder überprüfen Sie, ob die Kommunikation mit dem Kollektor funktioniert",
		"update_suc": "Upgrade erfolgreich",
		"deleteSuc": "Gelöscht erfolgreich",
		"Operation": "Betrieb",
		"edit": "Bearbeiten",
		"debug": "Fehlersuche",
		"upgrade": "Batch-Upgrade",
		"upgrade1": "Upgrade",
		"more": "Mehr Aktionen",
		"one_click_read": "Mit einem Klick lesen",
		'cloudsUpgrade': 'Cloud Upgrade',
		"queryUpgrade": "Batch-Prüfung des Upgrade-Fortschritts",
		"control": "Steuerelemente",
		"delete": "Löschen",
		"modify_alias": "Gerät bearbeiten",
		"serial_number": "Gerät SN：",
		"device_alias": "Name des Geräts：",
		"cancel": "Abbrechen",
		"confirm": "Bestätigung",
		"Device_sn": "Seriennummer des Geräts",
		"Device_pn": "das Gerät PN",
		"Instruction": "Befehl：",
		"such_as": "z.B. AA BB CC DD EE FF",
		"return_content": "Inhalt zurückgeben:",
		"send": "Befehl senden",
		"clear_data": "Daten löschen",
		"clear_val": "Löschen",
		"copy_val": "Kopieren",
		"copy_val_yes": "Kopie erfolgreich",
		"copy_val_no": "Kopie fehlgeschlagen",
		"Field_Name": "Feldname",
		"Unit": "Einheit",
		"current_val": "Aktueller Wert",
		"Battery_voltage": "Akku-Batteriespannung",
		"Magnification": "Multiplikator",
		"Send_Command": "Ausgegebener Befehl",
		"device_upgrade": "Upgrade der Gerätefirmware",
		'device_cloudsUpgrade': 'Upgrade der Gerätecloud',
		"select_firmware": "Firmware：",
		"select_file": "Bitte Firmware auswählen",
		"firmware_type": "Firmware-Typ：",
		"select_type": "Bitte wählen den Firmware-Typ",
		"upgrade_brate": "Baud:",
		"select_brate": "Bitte wählen die Baudrate",
		"Upload": "Firmware upload",
		"Upload1": "Neufirmware hochladen",
		"confirm_deldte": "Löschung bestätigen?",
		"deleteDevice": "Löschgrät",
		"Today_income": "Tageseinkommen aus der Stromerzeugung",
		"Cumulative_income": "Gesamteinnahmen aus der Stromerzeugung",
		"sellProfit_Today": "Tägliche Stromverkäufe",
		"sellProfit_Total": "Gesamteinnahmen aus Stromverkäufen",
		"buyProfit_Today": "Laufende Strombeschaffungskosten",
		"buyProfit_Total": "Gesamtkosten für den Stromkauf",
		"noAuth": "Kein zugehöriger Benutzer, keine Berechtigung zur Prüfung",
		"statistic": "Statistik",
		"protocolStatistic": "Statistik des Kommunikationsvereinbarung",
		"chooseProtocol": "Wählen die vereinbarung aus:",
		"parameter": "Parameter",
		"value": "Wert",
		"Upgrading": "Upgrade im Gange, bitte moment Wartung",
		"System_Failed": "wegen Komunikationdefekt oder andere Aufgrund führt Das System konnte den Geräte-Upgrade-Prozess nicht starten",
		"Device_Offline": "Gerät oder nummerspicker ist offline",
		"In_Upgrading": "Das Gerät oder der Nummerspicker wird bereits Eskalation",
		"Update_Completed": "Upgrade abgeschlossen",
		"Voltage": "Spannung",
		"Electric": "Strom",
		"power": "Leistung",
		"frequency": "Frequenz",
		"Input_form": "Eingangstabelle",
		"add": "Erhöhen",
		"Output_table": "Leistungsmesser",
		"Please_parameter": "Bitte wählen einen Parameter",
		"Successfully_modified": "Modifikation erfolgreich",
		"edit_control": "Berechtigungen zur Gerätesteuerung bearbeiten",
		"Equipment_agreement": "Gerätevereinbarung",
		"Check_all": "Alles markieren",
		"Cancel_all": "Alle beseitigen",
		"administrator_cansee": "Ausgewählte Berechtigungs Vertreter: Administrator sichtbar, keine Vertreter nicht sichtbar",
		"person_cansee": "Ausgewählte Berechtigungs Vertreter: Eigentümer sichtbar, keine Vertreter nicht sichtbar.",
		"admin_authority": "Rechte von Administrators",
		"person_authority": "Rechte von Eigentümers",
		"noDataPlease": "Keine Daten, bitte wählen die Zeit erneut",
		"Sn_deviceName": "SN / Gerätebezeichnung / PN / Benutzer",
		"deviceInfo": "Geräte-Informationen",
		"alarmInfo": "Alarm-Informationen",
		"deviceNo": "Sie haben keine Geräte zugesetzt",
		"showParam": "Parameter anzeigen",
		"selecParameters": "ausgewählte Parameter",
		"refresh": "Auffrischen",
		"obtain": "Erfassung",
		"moveResults": "Ergebnisse der Verschiebung",
		"moveSuc": "Verschiebung erfolgreich",
		"maxSelect": "max.bis zu 7 Parameter können angekreuzt werden",
		"minSelect": "Mindestens 1 Parameter muss angekreuzt werden",
		"loadMore": "Laden mehr...",
		"upDevice": "Geräte-Upgrade",
		'addUpgrade': 'Upgrade-Aufgabe hinzufügen',
		'upgradeProgress': 'Aktueller Upgrade-Fortschritt',
		'deviceUpgradeProgress': 'Fortschritt bei der Aufrüstung der Ausrüstung',
		'addUpgradeSuccess': 'Erfolgreich hinzugefügt',
				"unbind_tips": "Das Gerät ist nicht an einen Besitzer gebunden, bitte binden Sie zuerst den Besitzer",
		"device_code1": "Gerätecode"
	},
	"alarm": {
		"device_Warning": "Geräte Alarme",
		"device_Error": "Gerätefehler",
		"device_Fault": "Gerätedefekt",
		"Alarm_Event": "Alarm-Ereignisse",
		"Today_Alarm": "Anzahl der Alarme heute",
		"Alarm_Type": "Alarmtyp",
		"Device_Type": "Gerätetyp",
		"Alarm_Status": "Verarbeitungsstatus",
		"Alarm_List": "Alarmliste",
		"deletes": "Löschen",
		"tips": "Tipp",
		"details": "Details",
		"alarmDetails": "Alarmdetails",
		"alarmInfo": "Alarmsituation",
		"alarmDevice": "Geräteinformationen",
		"delete_alarm": "Sind Sie sicher, dass Sie diesen Alarm löschen möchten?",
		"Cancel": "Abbrechen",
		"Confirm": "Bestätigung",
		"Close": "schließen",
		"processed": "Verarbeitet",
		"untreated": "Unbearbeitet",
		"allAlarm": "Gesamtanzahl der Alarme",
		"alarmStatus": "Statistik für Status der Alarmbearbeitung ",
		"warningTitle": "Anzahl der Alarme in den letzten 7 Tagen",
		"faultTitle": "Anzahl der Störungen in den letzten 7 Tagen",
		"alarmNum": "Anzahl der Alarme",
		"faultNum": "Anzahl der Störungen",
		"all": "Alle",
		"warning": "Alarme",
		"error": "Fehler",
		"fault": "Störung",
		"offline": "Offline",
		"inverter": "Wechselrichter",
		"monitor": "Umgebungsprüfgrät",
		"smart_meters": "Intelligente strom Zähler",
		"combining_manifolds": "Verteilerdosen",
		"Camera": "Kamera",
		"Battery": "Batterie",
		"Charger": "Ladegerät",
		"storage": "Energiespeichermaschinen",
		"Prevent_arcing_island": "Anti-Islanding-Geräte",
		"Microinverter": "Mikro-Wechselrichter",
		"Occurrence_time": "Zeitpunkt des Auftretens",
		"endtime": "Endzeitpunkt",
		"Device_Name": "Name des Geräts",
		"Device_PN": "Nummerspicker PN-Nummer",
		"Plant": "zugehörige Station",
		"Alarm_Code": "Alarm-Code",
		"Alarm_Describe": "Beschreibung des Alarms",
		"Device_SN": "Gerät SN",
		"device_alias": "Geräte-Alias",
		"device_address": "Gerät Adresse",
		"User": "yugehöriger Benutzer",
		"Status": "Status",
		"Operation": "Betrieb",
		"Delete_selected": "Löschen ausgewählte",
		"deleted_successfully": "Alarm erfolgreich gelöscht!",
		"Alarm_Msg": "Neue Info",
		"Intro_Msg": "Anleitung für Einsteiger",
		"Alarm_Read": "Sie haben alle Alarme gelesen",
		"Alarm_data": "Vorläufige keine weiteren Nachrichten!",
		"Alarm_Message": "Ihr",
		"Alarm_Message1": "Gerät erscheint",
		"curSelected": "Aktuelle ausgewählte",
		"_Data": "Daten",
		"more": "mehr",
		"ruleManage": "Verwaltung von Alarmfilterregelung",
		"ruleNew": "Neue Regel",
		"ruleName": "Name der Regel",
		"timeSlot": "Zeitspanne",
		"deviceType": "Gerätetyp",
		"deviceFilter": "Filtergerät",
		"alrmType": "Filteralarmtyp ",
		"alrmDes": "Filteralarm Beschreibung",
		"filterHistory": "Verlauf filtern",
		"clearHistory": "Historie löschen",
		"view": "siehe",
		"back": "Zurück",
		"exportArchive": "Archivierte Warnung exportieren",
		"archiveRecord": "Archiv",
		"archiveTip": "Die Liste enthält alle unbearbeiteten Warnungen und bearbeitete Datensätze innerhalb von 7 Tagen"
	},
	"datalogger": {
		'activeStatus': 'Aktivierungsstatus',
		'Active': 'Aktiviert',
		'notActive': 'Nicht aktiv',
		'timeZone': 'Zeitzone',
		"please_title": "Bitte geben Sie 'JA' ein, um den Status des Werksresets zu bestätigen",
		"frequency": "Sammelhäufigkeit",
		"heartbeat": "Herzschlag",
		"warehousing_time": "Lagerzeit",
		"start_address": "Start-Adresse der Umfrage",
		"deadline_address": "Deadline address",
		"title_usr": "Dieser Datensammler hat keinen verbundenen Benutzer",
		"datalogger_log": "Log",
		"min_addr": "Mindestadresse",
		"max_addr": "Maximale Adresse",
		"transmission": "Reine transparente Identifikation",
		"transparent_set": "Reiner transparenter Protokollsatz",
		"devcode": "Gerätehersteller-Code",
		"protocol_code": "Protocol hersteller code",
		"domain_name": "Online domain name",
		"transmission1": "Local collection mode",
		"transmission2": "Rein transparenter Modus",
		"noDate": "Bitte wählen Sie ein Datum innerhalb von drei Tagen",
		"paramSetting": "Parameter settings",
		"paramName": "Parametername",
		"paramPar": "Parameter number",
		"paramVal": "Der Wert des Parameters",
		"dataloggerView": "Data collector details",
		"describe": "Description",
		"field_name": "Feldname",
		"checkVal": "Numerischer Wert",
		"resetTitle1": "Sind Sie sicher, dass Sie den Datensammler zurücksetzen möchten? (1: ihn wieder registrierbar machen, 2: untergeordnete Geräte löschen, 3: alle Daten unter dem Collector löschen)",
		"unbingTitle": "Möchten Sie den Datensammler wirklich aufheben? (1: Den Händleradministrator aufheben; 2: Rebind, bitte melden Sie sich beim entsprechenden Händleradministrator an, um den Datensammler hinzuzufügen)",
		"getTitle": "Parameter acquisition",
		"postTitle": "Parameter Settings",
		"debugeTitle": "Setting up debugging",
		"getName": "Parametererfassung (dezimal)",
		"postName": "Parameter number (decimal)",
		"debugeName": "Befehl:",
		"getVal": "Current value:",
		"postVal": "Setting value:",
		"debugeVal": "Ergebnis:",
		"debugeAddr": "Geräteadresse:",
		"getSucc": "Erfolgreich erhalten",
		"postSucc": "Erfolgreich eingestellt",
		"debugeSucc": "Erfolgreich ausgestellt",
		"copyVal": "Copy value",
		"huoqu": "Get",
		"shezhi": "Einstellungen",
		"xiafa": "Befehl erteilen",
		"copy": "Kopie erfolgreich",
		"flowCard": "Gültige Karte nicht abgefragt",
		"province": "provinz/Land",
		"city": "Stadt",
		"county": "Landkreis/Region/District",
		"country": "Staat",
		"Flowcard_status": "Verkehr Kartenstatus",
		"GPRS_traffic": "GPRS-Durchflussigmenge",
		"upBatchDataloggerTip": "Hinweis: Das Batch-Upgrade dient dazu, dieselbe Digitalisierer-Firmware für mehrere Digitalisierer zu aktualisieren. Bitte wählen Sie sorgfältig aus, wenn Sie nicht sicher sind, welche Firmware für den Digitalisierer geeignet ist!",
		"upSuccessDatalogger": "Erfolgreich aktualisierte Nummerspicker",
		"upFailDatalogger": "Fehlgeschlagene Upgrades",
		"Datalogger_Status": "Status der Nummerspickers",
		"com_method": "Kommunikationsmethode",
		"Datalogger_PN": "Nummerspicker PN-Nummer",
		"Datalogger_List": "Liste der Nummerspicks PN",
		"Datalogger_Name": "Name des Nummerspickers",
		"Ple_PN": "Bitte die PN-Nummer des Nummerspickers eingeben",
		"Ple_Alias": "Bitte den Namen des Nummerspickers eingeben",
		"Datalogger_type": "Nummerspickers-Typ",
		"Datalogger_model": "Modell",
		"Datalogger_method": "Kommunikationsmethode",
		"Status": "Status",
		"usr_belong": "yugehöriger Benutzer",
		"administrator": "zugehöriger Verwalter",
		"Communication_balance": "Differenzbetrag der Kommunikationsgebühren",
		"load": "Bandbreite",
		"Firmware_Version": "Firmware-Version",
		"signal": "Signal",
		"Operation": "Betrieb",
		"edit": "Bearbeiten",
		"reboot": "Neustart",
		"unbind": "Entbündeln",
		"more": "mehr",
		"resetData": "Daten zurücksetzen",
		"unbindUsr": "Besitzer entbündeln",
		"debug": "Fehlersuche",
		"upgrade": "Upgrade",
		"delete": "Löschen",
		"deleteTitle": "Nummerspicker löschen",
		"reset": "Zurücksetzen",
		"resetCode": "Zur Bestätigung bitte JA/yes eingeben",
		"modify_datalog": "Informationen zum Nummerspicker ändern",
		"cancel": "Abbrechen",
		"confirm": "Bestätigung",
		"datalogger_debug": "Inbetriebnahme des Nummerspicker",
		"communication_address": "Kommunikationsanschrift：",
		"Instruction": "Befehl：",
		"such_as": "z.B. AA BB CC DD EE FF",
		"return_content": "Inhalt zurückgeben:",
		"send": "Befehl senden",
		"check": "Prüfung",
		"InstructionType": "Befehlsformat",
		"endMarker": "Endmarkierung",
		"noMarker": "Keine Endmarkierung",
		"noCheck": "Keine Prüfung",
		"InstructionIssue": "Befehl senden",
		"Insufficient": "Nicht genügend Wiederholungen",
		"clear_data": "Daten löschen",
		"device_upgrade": "Upgrade der Gerätefirmware",
		"select_firmware": "Firmware：",
		"select_file": "Bitte Firmware auswählen",
		"Upload": "Firmware upload",
		"prompt_message": "Aufforderungsmeldung",
		"confirm_deldte": "Nach dem Löschen des Nummerspicker haben Sie keine mehr das Recht, alle Daten des Nummerspickers zu verwalten.",
		"Normal": "Normal",
		"Online": "Online",
		"Offline": "Offline",
		"Normal1": "Online-Status",
		"Offline1": "Offline-Status",
		"Allstate": "Alle Status",
		"modifySuc": "Modifikation erfolgreich",
		"resetSuc": "Zurücksetzen erfolgreich",
		"unbindSuc": "Entbündelt erfolgreich",
		"devaddrfail": "Kommunikationsadresse darf nicht leer sein",
		"Debugfail": "Debugging fehlgeschlagen, Nummerspickr ist offline",
		"instruction_response": "Befehl wird gesendet, warte auf Antwort...",
		"fileExceed": "Die Datei ist zu groß",
		"uploadSuccess": "Upload erfolgreich",
		"error1": "Es können nur Dateien im \".bin\" und \".hex\" Format hochgeladen werden",
		"file_fist": "Bitte wählen Sie zuerst die zu aktualisierende Firmware aus",
		"updatefail": "Upgrade fehlgeschlagen, Kollektor ist möglicherweise offline, oder überprüfen Sie, ob die Kommunikation mit dem Kollektor funktioniert",
		"update_suc": "Upgrade erfolgreich",
		"deleteSuc": "Gelöscht erfolgreich",
		"debug_suc": "Debugging erfolgreich",
		"create": "Erstellung",
		"addSuc": "Nummerspicker hinzufügen erfolgreich",
		"add": "Gerät hinzufügen",
		"addScq": "eines Nummerspicker hinzufügen",
		"batchAddScq": "Batch Nummerspicker hinzufügen",
		"editDatalogger": "Nummerspicker modifizieren",
		"editDataloggerName": "Nummerspicker bearbeiten",
		"resetDataloggerName": "Nummerspicker zurücksetzen",
		"unbindDataloggerName": "Nummerspicker entbündeln",
		"resetDataloggerExplain": "Diese Funktion wird hauptsächlich von Herstellern verwendet, um die Cloud-Testdaten ihrer Geräte zu löschen. Nach dem Zurücksetzen des Nummerspicker werden die historischen Daten des Geräts gelöscht, nach der Betätigung können die historischen Daten des Geräts nicht wiederhergestellt werden, bitte mit Vorsicht bediennen!",
		"unbindDataloggerExplain": "Diese Funktion dient hauptsächlich der Bequemlichkeit der Hersteller, um das Testkonto (das dem Eigentümer gehört) nach dem Ende des Tests vor der Auslieferung vom Nummerspicker zu löschen; bitte bedienen Sie diese Funktion mit Vorsicht, nach der Bedienung muss der Kunde den Nummerspicker erneut verbinden.",
		"rebootDataloggerName": "Neustart des Nummerspickers",
		"rebootDataloggerSuc": "Erfolgreicher Neustart des Nummerspickers",
		"fixOnRebootDataloggerName": "Bestätigung des Neustarts des Nummerspickers:",
		"fixOnRebootDataloggerName1": "Ist es?",
		"unbindTitle": "Bitte geben \"JA\" ein, um zu bestätigen, dass Sie die Bindung des Nummerpicker vom aktuellen Terminalbesitzer löschen möchten.",
		"resetTitle": "Bitte geben \"JA\" ein, um zu bestätigen, dass den Nummerspicker zurücksetzen will.",
		"editSuc": "Erfolgreiche Änderung des Nummerspickers",
		"basic_info": "Grundlegende Informationen",
		"datalogger_pn": "Numerischer Picker PN：",
		"datalogger_name": "Name des Nummerspickers：",
		"nominalPower": "festgesetzte Leistung",
		"install_date": "die Installationszeit",
		"installer": "Installateur",
		"location_info": "Standort Information",
		"location_info1": "Geografische Informationen",
		"district": "Städtisches Verwaltungsgebiet",
		"address": "Standort des Nummerspickers",
		"dataloggerAddress": "detail Adresse",
		"enterPosition": "den Standort des Nummerspicker eingeben",
		"longi_lati": "Breitengrad und Längengrad",
		"latitude": "Breitengrad ",
		"longitude": "Längengrad",
		"currentAddress": "Aktuelle Adresse：",
		"timezone": "Zeitzone",
		"timezone1": "Zeitzone",
		"cp1": "Bitte wählen das Termin der Installation",
		"cp2": "Bitte wählen eine Zeitzone",
		"cp3": "Bitte die Nennleistung eingeben",
		"cp4": "Bitte wählen die Umsatzwährung",
		"cp5": "Bitte den Namen des Geräts eingeben",
		"cp6": "Bitte wählen zugehöriger Projekt aus",
		"cp7": "Bitte wählen Sie Breiten- und Längengrad",
		"lonRange": "Zahlen mit einem Längenbereich von -180 bis 180",
		"latRange": "Zahlen innerhalb des Breitengrades von -90 bis 90",
		"cp9": "Bitte geben Sie die aktuelle Adresse ein",
		"cp10": "Bitte den Namen des Projekts eingeben",
		"income_info": "Informationen zur Einnahme",
		"currency": "Währung der Einnahme：",
		"buyProfit": "Preis des einkauften Stroms：",
		"sellProfit": "Preis des verkauften Stroms：",
		"unitProfit": "Preis des verbrauchten Stroms：",
		"generateProfit": "Preis des erzeugten Stroms：",
		"noNegative": "Bitte geben Sie eine nicht negative Zahl ein",
		"buyProfitNew": "Preis des einkauften Stroms",
		"sellProfitNew": "Preis des verkauften Stroms",
		"generateProfitNew": "Preis des erzeugten Stroms",
		"add_datalogger": "Der Nummerspicker neue hinzufügen",
		"add_suc": "Erfolgreich hinzugefügt",
		"basicInfo": "Grundlegende Informationen",
		"connectionInfo": "Informationen zum Anschluss",
		"finishAdding": "Hinzufügung abgeschlossen",
		"addResults": "Ergebnisse der Hinzufügung",
		"addedSuccessfully": "Erfolgreich hinzugefügt",
		"finish": "Erledigung",
		"continueAdding": "Hinzufügen fortsetzen",
		"nowNoAdd": "momentan Noch nicht hinzugefügt",
		"reAdd": "erneut hinzufügen",
		"editResults": "Ergebnis der Modifizierung",
		"resetResults": "Ergebnis zurücksetzen",
		"unbindResults": "Ergebnis entbinden",
		"delResults": "Ergebnis löschen",
		"locationTip": "Tipp: kann manuell eingeben, wenn die Positionierung ungenau oder ungültig ist.",
		"upDatalogger": "Nummerspicker aufrüsten",
		"dataloggerTipName": "Der Sammler wurde hinzugefügt, hinzugefügt von",
				"batch_edit_datalogger": "Datalogger stapelweise bearbeiten",
				"upload_column_tips": "Freundlicher Hinweis: Spalte A ist Datalogger-PN, Spalte B ist Lastanzahl, Spalte C ist Baudrate, Spalte D ist Kommunikationsprotokoll, Spalte E ist Geräteherstellercode, Spalte F ist Protokollherstellercode, Spalte G ist Erfassungsmodus, Spalte H ist min. Kommunikationsadresse, Spalte I ist max. Kommunikationsadresse, kein Titel erforderlich, siehe folgendes Bild",
				"upload_csv_tips": "Freundlicher Hinweis: Das Dateiformat muss csv sein, siehe folgendes Bild für den Dateiinhalt",
				"click_enlarge": "Zum Vergrößern klicken",
						"collector_expire_time": "Ablaufzeit des Sammlers",
						"collection_cycle": "Sammelzyklus",
								"ascii_display": "ASCII-Anzeige:"
	},
	"map": {
		"sn": "Gerät SN:",
		"datalogger": "Name des Nummerspickers：",
		"address": "Geräteadresse："
	},
	"rate": {
		"device_status": "Status der Ausrüstung",
		"datalogger_pn": "Numerischer Picker PN",
		"datalogger_pns": "Numerischer Picker PN：",
		"rate_list": "Tarifliste",
		"datalogger_name": "Name des Nummerspickers",
		"status": "Status",
		"Income_currency": "Währung der Einnahme",
		"Income_currencys": "Währung der Einnahme：",
		"generate_Rate": "Stromerzeugungstarife",
		"generate_Rates": "Stromerzeugungstarife:",
		"sell_Rate": "Verkaufstarife",
		"sell_Rates": "Verkaufstarife:",
		"buy_Rate": "Einkaufetarif",
		"buy_Rates": "Einkaufetarif:",
		"operating": "Betrieb",
		"edit": "Bearbeiten",
		"rate": "Tarife",
		"cancel": "Abbrechen",
		"confirm": "Bestätigung",
		"modifySuc": "Modifikation erfolgreich",
		"resetSuc": "Zurücksetzen erfolgreich",
		"unbindSuc": "Entbündelt erfolgreich"
	},
	"auxiliary": {
		"auxiliaryFunction": "Zusätzliche Funktion",
		'chartSupplement': 'Reales Diagramm',
		'realChart': 'Nach dem Öffnen zeigt das Diagramm reale Daten an.',
	},
	// 增
	"strategy": {
		'strategyUpgrade': 'Strategieliste aktualisieren',
		'to': 'Zurück',
		'UpgFirmware': 'Lokale Firmware-Verwaltung',
		'strategyIntro': 'Überblick über den lokalen Upgrade-Prozess',
		'strategyInfor': 'Informationen zur Upgrade-Richtlinie',
		'strategyIntro1': 'Beschreibung: Dieses Funktionsmodul ist nur für das lokale Firmware-Upgrade von Bluetooth. Wenn Sie die Firmware von Geräten wie Wi-Fi oder 4G aktualisieren möchten, wechseln Sie bitte zu [Device Management Device List Upgrade Operation]',
		'stategyStep2': 'Neues Firmware-Versionspaket',
		'stategyStep3': 'Laden Sie Paketdateien der Firmware-Version in die lokale Firmware-Verwaltung hoch',
		'stategyStep4': 'APP Local Upgrade',
		'stategyStep5': 'Nachdem die Strategie wirksam wird, erhält die APP eine Upgrade-Erinnerung und kann lokal upgraden',
		'stategyStep6': 'Upgrade-Strategie hinzufügen',
		'stategyStep7': 'Fügen Sie eine neue Strategie in der Liste der Upgrade-Strategien hinzu, wählen Sie Firmware aktualisieren, legen Sie die Upgrade-Methode fest und werden wirksam, verknüpfen Sie das Upgrade-Gerät und generieren Sie die Upgrade-Strategie',
		'stategyStep8': 'Upgrade-Datensätze anzeigen',
		'stategyStep9': 'Status und Ergebnisse des Geräteupgrades anzeigen',
		'stategyDetail': 'Name der Richtlinie',
		'stategyDetail1': 'Firmware aktualisieren',
		'stategyDetail2': 'Größe des Firmware (KB)',
		'stategyDetail3': 'Firmware-Typ',
		'stategyDetail4': 'Baudrate',
		'stategyDetail5': 'Upgrade-Methode',
		'stategyDetail6': 'Upgradefortschritt',
		'stategyDetail7': 'Status der Richtlinie',
		'stategyDetail8': 'Startzeit',
		'stategyDetail9': 'Ablaufzeit',
		'upgradeList': 'Datensatzliste aktualisieren',
		'add_strategy': 'Strategieliste aktualisieren',
		'strategy_time': 'Wirksame Zeit',
		'strategy_code': 'Kodierung von Richtlinien',
		'strategy_name': 'Name der Richtlinie',
		'strategy_desc': 'Beschreibung der Richtlinie',
		'strategy_firmware': 'Firmware aktualisieren',
		'strategy_type': 'Firmware-Typ',
		'strategy_baudrate': 'Baudrate',
		'uprade_type': 'Upgrade-Methode',
		'uprade_name': 'Upgrade erzwingen',
		'uprade_name1': 'Vorgeschlagene Aktualisierung',
		'uprade_result': 'Upgradeergebnisse',
		'uprade_success': 'Upgrade erfolgreich',
		'uprade_fail': 'Upgrade fehlgeschlagen',
		'uprade_status': 'Upgrade-Status',
		'uprade_time': 'Upgradezeit',
		'strategy_number': 'Menge',
		'strategy_status': 'Status der Richtlinie',
		'start_time': 'Startzeit',
		'end_time': 'Ablaufzeit',
		'edit': 'Bearbeiten',
		'edit_strategy': 'Richtlinie bearbeiten',
		'view': 'Prüfung',
		'view_strategy': 'Richtlinien anzeigen',
		'cancel': 'Abbrechen',
		'cancel_strategy': 'Stornierungsbedingungen',
		'force_upgrade': 'Upgrade erzwingen',
		'suggested_upgrade': 'Vorgeschlagene Aktualisierung',
		'In_effect': 'In der Tat',
		'expired': 'Abgelaufen',
		'Not_started': 'Nicht gestartet',
		'Not_upgraded': 'Nicht aktualisiert',
		'Yes_started': 'Verbessert',
		'policy_information': 'Politikinformationen',
		'associated_device': 'Zugehörige Geräte',
		'completion_strategy': 'Abschlussstrategie',
		'upgrade_strategy_list': 'Strategieliste aktualisieren',
		'Next': 'Nächster Schritt',
		'TOP': 'Vorheriger Schritt',
		'confirm': 'Bestätigen',
		'go_back': 'Zurück',
		'strategy_detail': 'Details zur Strategie',
		'strategy_search': 'Policy Code/Policy Name',
		'strategy_upgrade_search': 'Gerät SN/Datelogger PN',
		'upgrade_remind': 'Upgrade-Erinnerung',
		'remind_desc': 'Beschreibung der Erinnerung',
		'default_desc': 'Standardbeschreibung',
		'default_desc1': "Dieses Gerät muss auf eine höhere Version aktualisiert werden, bevor es verwendet werden kann. Klicken Sie auf 'Upgrade erzwingen', um ein Upgrade durchzuführen. Bitte trennen Sie die Bluetooth-Verbindung nicht und sorgen Sie für einen reibungslosen Netzwerkbetrieb während des Upgrades.",
		'message_name': 'Bitte geben Sie einen Policennamen ein',
		'message_desc': 'Bitte geben Sie eine Beschreibung der Richtlinie ein',
		'message_firmware': 'Bitte Firmware auswählen',
		'message_type': 'Bitte wählen Sie den Firmware-Typ',
		'message_baudrate': 'Bitte wählen Sie die Baudrate',
		'message_timezone': 'Bitte wählen Sie eine Zeitzone',
		'message_time': 'Bitte wählen Sie einen gültigen Zeitpunkt',
		'message_uprade_type': 'Bitte wählen Sie den Upgrade-Typ',
		'delete_firmware': 'Sind Sie sicher, dass Sie diese Richtlinie kündigen möchten?',
		'delete_desc': 'Nach der Stornierung ist eine Wiederherstellung nicht möglich und die gewählte Upgrade-Strategie kann das Gerät nicht über ein Upgrade benachrichtigen',
		'Upgrade_tip': 'Bitte wählen Sie das Gerät aus, das der Richtlinie zugeordnet ist',
		'Upgrade_result': 'Erfolgreich hinzugefügt',
		'start_date': 'Datum des Inkrafttretens',
		'End_date': 'Ablaufdatum',
		"limits":     "Hinweis: In der hochgeladenen Datei muss Spalte A die PN des Data-Loggers enthalten; keine Kopfzeile erforderlich – siehe Beispielbild unten.",
		"mueas":      "Upgrade-Strategie",
		"upNum":      "Anzahl der zu aktualisierenden Geräte",
		"deletCL":    "Strategie löschen",
		"deletCL_TEST":"Sind Sie sicher, dass Sie diese Strategie löschen möchten?",
		"ONE_UP":     "Einzelgeräte-Upgrade",
		"MO_UP":      "Geräte-Bulk-Upgrade",
		"MO_text": "Erfolgreich importiert",
"MO_tex1": "Duplikat",
"MO_tex3": "Nicht gefunden",
"MO_tex2": "Organisation",
"MO_tex4": "Die Firmware wird in einer aktiven Strategie verwendet und kann nicht gelöscht werden.",
	},
	"cloudsUpgarde": {
		'cloudsFirmware': 'Cloud Upgrade Firmware',
		'cloudsFirmwareList': 'Cloud Upgrade Liste',
	},
	"upgradeManagement": {
		'create': 'Etablieren',
		'cancel': 'Abbrechen',
		'confirm': 'Bestätigen',
		'upload_firmware': 'Firmware hochladen',
		'edit_firmware': 'Firmware bearbeiten',
		'download_firmware': 'Firmware herunterladen',
		'delete_desc': 'Nach dem Löschen ist es nicht möglich, wiederherzustellen, und die für diese Firmware ausgewählte Upgrade-Strategie kann das Gerät nicht aktualisieren',
		'eidt_success': 'Erfolgreich bearbeitet',
		'delete_success': 'Erfolgreich abgebrochen',
		'delete_success1': 'Erfolgreich gelöscht',
		'download_success': 'Download erfolgreich',
		'firmware_name': 'Name des Firmware',
		'Firmware_Version': 'Versionsnummer',
		'please_upgrade': 'Bitte wählen Sie die Upload-Datei aus',
		'upgrade_success': 'Erfolgreich hochgeladene Firmware',
		'please_input': 'Bitte geben Sie ein',
		'Remarks': 'Firmware Beschreibung',
		'Upload': 'Firmware hochladen',
		'download_firmware_prompt': 'Sind Sie sicher, dass Sie diese Firmware herunterladen möchten?',
		'upgrade_file_format': 'Kann nur im .bin/.hex Format hochgeladen werden, darf 1MB nicht überschreiten',
		'upgrade_file_format1': 'Kann nur im .bin/.hex Format hochgeladen werden',
		'upgrade_file_format2': 'Die Datei darf 1MB nicht überschreiten',
		'firmwareName_empty': 'Firmware Name kann nicht leer sein',
		'firmwareVersion_empty': 'Versionsnummer kann nicht leer sein',
		"download_exception": "Download Ausnahme, bitte versuchen Sie es später erneut",
		"upload_result": "Ergebnis hochladen",
	},
	"project": {
		"choice": "Durchlauf",
		"move": "Verschieben",
		"manageProject": "Projektverwaltung",
		"project": "Angehängte Elemente",
		"defaultProject": "Standard-Element",
		"projectName": "Projektname",
		"projectRemark": "Darstellung des Projekts",
		"projectId": "Projekt-ID",
		"createProject": "Neubau Projekt",
		"createResults": "Neues Erstellungsergebnis",
		"createSuc": "Neue Erstellung Erfolgreich",
		"editProject": "Projekt bearbeiten",
		"editResults": "Ergebnis bearbeiten",
		"editSuc": "Bearbeitung erfolgreich",
		"delProject": "Löschen eines Elements",
		"delResults": "Ergebnis löschen",
		"delSuc": "Gelöscht erfolgreich",
		"upgradeResults": "Ergebnisse aktualisieren",
		"upgradeSuc": "Upgrade erfolgreich",
		"back": "Zurück",
		"placeholder": "Suche nach Gerätename/PN/SN",
		"modifySuc": "Erfolgreich ",
		"upload": "Ein Bild hochladen",
		"limit": "(Bildgröße bis zu nicht mehr 1M)",
		"moveTo": "Verschieben nach",
		"moveSelect": "Verschieben der ausgewählten",
		"deviceSn": "Gerät SN",
		"tipCard": "Karte",
		"tipList": "Auflistung",
		"tipSearchSN": "Suche nach Gerät",
		"tipSearchPN": "Suche nach Nummerspicker",
		"energyCurrent": "Aktuelle Leistung",
		"energyDate": "Stromerzeugung bei aktuellen Tag",
		"energyMonth": "Stromerzeugung Aktueller Monat",
		"energyYear": "Stromerzeugung Aktuelles Jahr",
		"energyTotal": "Gesamte Stromerzeugung"
	},
	"constant": {
		"renminbi": "Renminbi (¥)",
		"meiyuan": "USD ($)",
		"ouyuan": "Euro (€)",
		"aoyuan": "Australischer Dollar ($A)",
		"yingbang": "Britisches Pfund (£)",
		"gangbi": "Hongkong-Dollar (HK$)",
		"ruidian": "Schwedische Krone (Kr)",
		"lubi": "Indische Rupie (₹)",
		"moxige": "Mexikanischer Peso (Mex$)",
		"baxi": "Real (R$)",
		"Pakistani": "Pakistanische Rupie (Rs)",
		"Rand": "Südafrikanischer Rand(R)",
		"gmt0": "(GMT +00:00) Dublin, Edinburgh, Lissabon, London, Casablanca, Koordinierte Weltzeit",
		"gmt_1": "(GMT +01:00) Paris, Madrid, Kopenhagen, Rom, Wien, Berlin, Amsterdam, Zentralafrika West",
		"gmt_2": "(GMT +02:00)Amman, Damaskus, Kairo, Athen, Jerusalem, Istanbul",
		"gmt_3": "(GMT +03:00)Bagdad, Kuwait, Riyadh, Nairobi, Teheran",
		"gmt_4": "(GMT +04:00)Abu Dhabi, Muscat, Eriwan",
		"gmt_5": "(GMT +05:00)Islamabad,Karatschi",
		"gmt_55": "(GMT+05:30) Neu Delhi",
		"gmt_6": "(GMT +06:00)Dhaka, Astana, Jekaterinburg",
		"gmt_65": "(GMT +06:30) Myanmar",
		"gmt_7": "(GMT +07:00)Bangkok, Hanoi, Jakarta, Nowosibirsk",
		"gmt_8": "(GMT +08:00)Peking, Chongqing, Hongkong SAR, Urumqi, Taipeh, Kuala Lumpur, Singapur",
		"gmt_9": "(GMT +09:00)Osaka, Tokio, Seoul",
		"gmt_10": "(GMT +10:00)Brisbane,Guam,Canberra,Melbourne,Sydney",
		"gmt_11": "(GMT +11:00)Salomonen, Wladiwostok, Neukaledonien",
		"gmt_12": "(GMT +12:00)Auckland,Wellington,Fidschi,Magadan",
		"gmt_13": "(GMT +13:00)Nuku'alofa",
		"gmt_neg_1": "(GMT -01:00)Kapverdische Inseln, Azoren",
		"gmt_neg_2": "(GMT -02:00)Mittlerer Atlantik",
		"gmt_neg_3": "(GMT -03:00)Brasilia, Buenos Aires, Grönland, Cayenne",
		"gmt_neg_4": "(GMT -04:00)Atlantikzeit (Kanada), Cuiaba, La Paz, Santiago",
		"gmt_neg_5": "(GMT -05:00)EST (USA und Kanada), Indiana (Ost)",
		"gmt_neg_6": "(GMT -06:00) MEZ (USA und Kanada), Mittelamerika, Mexiko-Stadt, Monterrey, Guadalajara",
		"gmt_neg_7": "(GMT -07:00)Bergzeit (USA und Kanada), Chihuahua, La Paz, Mazatlan, Arizona",
		"gmt_neg_8": "(GMT -08:00)Pazifische Zeit (USA und Kanada), Niederkalifornien",
		"gmt_neg_9": "(GMT -09:00)Alaska",
		"gmt_neg_10": "(GMT -10:00)Hawaii",
		"gmt_neg_11": "(GMT -11:00)Samoa",
		"gmt_neg_12": "(GMT -12:00)Internationale Datumsgrenze West"
	},
	"basic": {
		"modifySuc": "Modifikation erfolgreich!",
		"Personal_info": "Änderung von Informationen",
		"User_name": "Benutzername：",
		"User_name1": "Benutzername",
		"Nickname": "Spitzname：",
		"Nickname1": "Spitzname",
		"editNickname": "Spitzname ändern",
		"Ple_Nickname": "Bitte geben einen Spitznamen ein",
		"setNickname": "Spitzname festlegen",
		"Email": "Mailbox：",
		"Email1": "E-Mail ",
		"Email2": "E-Mail:",
		"editEmail": "Ändern E-Mail-Adresse",
		"setEmail1": "Binden Sie Ihre E-Mail-Adresse",
		"Mobile": "Handynummer:",
		"Mobile1": "Handynummer",
		"editMobile": "Ändern Handynummer",
		"setMobile": "Binden Handynummer",
		"Avatar": "Benutzer-Bilder",
		"basic": "Persönliche Informationen",
		"Save": "speichern",
		"Select_all": "Alle Optionen wiederherstellen",
		"Ple_phone": "Bitte geben die Handynummer ein, die Sie binden möchten",
		"code": "Verifizierungs-Code:",
		"Ple_code": "Bitte geben Sie den Bestätigungscode ein",
		"Obtain_code": "Verifizierungscode abrufen",
		'Bind_phone': 'Telefon binden',
		"After_bindingPh": "Nachdem Sie Ihr Mobiltelefon gebunden haben, können Sie Ihr Passwort über Ihr Mobiltelefon abrufen",
		"Untie_phone": "Bindung Ihres Mobiltelefons aufheben",
		"Change_phone": "Mobiltelefon wechseln",
		"Bind_email": "E-Mail verbunden",
		"Ple_email": "Bitte geben die E-Mail-Adresse ein, die gebunden werden möchte",
		"re_enter": "Erneut abrufen",
		"After_bindingEm": "Nachdem Sie Ihre E-Mail-Adresse gebunden haben, können Sie Ihr Passwort über Ihre E-Mail-Adresse abrufen",
		"Unbind_email": "Binden Sie Ihre Mailbox auf",
		"Change_email": "Mailbox ändern",
		"unbind_Ph": "die Bindung des Handynummer aufheben bestätigen?",
		"unbinding_Ph": "Nach dem Aufheben der Bindung wird Passwort nicht mehr über Handy abrufen!",
		"unbind_Em": "die Bindung der E-Mail-Adresse aufheben wollen?",
		"unbinding_Em": "Nach der Aufhebung der Bindung kann Ihr Kennwort nicht mehr über E-Mail-Adresse abrufen!",
		"mobile_code": "Der Verifizierungscode wurde an Ihr Mobiltelefon gesendet, bitte achten darauf, ihn zu erhalten",
		"email_code": "Der Bestätigungscode wurde an Ihre Mailbox gesendet, bitte achten Sie darauf, ihn zu erhalten",
		"suc_ph": "Bindung der Mobiltelefonnummer erfolgreich",
		"suc_em": "Bindung der Mailbox erfolgreich",
		"code_frequently": "Der Verifizierungscode wird häufig gesendet, bitte versuchen später wieder einmal",
		"personalCenter": "Konto-Einstellungen",
		"basicInfo": "Grundlegende Informationen",
		"accountSecurity": "das Konto ist sicher",
		"backTo": "Zurück",
		"uploadAvatar": "Ändern Sie Ihren Avatar",
		"bindPhone": "Handy-gebunden",
		"bindEmail": "E-Mail-gebunden",
		"changePwdTip": "Ein hochsicherliche Passwort macht Ihr Konto mehr Sicherheit. Es wird empfohlen, das Passwort regelmäßig zu ändern und ein 6- bis 32-stelliges Passwort zu setzen.",
		"bindPhoneTipBefore": "Mobiletelefon gebunden:",
		"bindEmailTipBefore": "E-Mail gebunden:",
		"bindPhoneTip": "ein Mobiltelefon einrichten, um sich anzumelden, den Passwort abzurufen und Benachrichtigungen vom System zu erhalten.",
		"bindEmailTip": "eine E-Mail-Adresse einrichten, um sich anzumelden, und Kennwort abzurufen und Benachrichtigungen vom System zu erhalten.",
		"bindPhoneTipAfter": "es kann anmelden, und Kennwort abrufen auch Benachrichtigungen vom System erhalten.",
		"changeBtn": "Änderung",
		"changePwd": "Passwort ändern",
		"changePwdSuc": "Passwort zurücksetzen erfolgreich",
		"finished": "Erledigung",
		"retry": "Wiederholen",
		"changeRes": "Ergebnis der Modifizierung",
		"bindRes": "Ergebnis der Bindung",
		"noHanzi": "Passwort kann kein Chinesisch enthalten",
		"Nickname_length_tip": "Benutzernamen von 2 bis 32 Bit"
	},
	"password": {
		"User_name": "Benutzername:",
		"Password": "Passwort ändern",
		"Current_password": "Altes Kennwort",
		"New_password": "Neues Passwort：",
		"Config_newpassword": "das neue Passwort bestätigen",
		"PLCurrent_password": "Bitte altes Passwort eingeben",
		"PLNew_password": "Bitte neues Passwort eingeben",
		"PLConfig_newpassword": "Bitte das neue Passwort bestätigen",
		"editPwdSuc": "Passwortänderung erfolgreich",
		"loginAgain": "Passwortänderung erfolgreich, bitte erneut anmelden",
		"Save": "speichern"
	},
	"settingalarm": {
		"chosesstation": "Bitte das Kraftwerk auswählen",
		"addEmails": "Mailbox hinzufügen",
		"delete": "Mailbox erfolgreich gelöscht",
		"deletes": "Löschen",
		"Email_List": "Mailingauflistung",
		"Add_Mailbox": "Mailbox-Push hinzufügen",
		"cancel": "Abbrechen",
		"Add": "Erhöhen",
		"Email_Setting": "Mail-Push-Einstellungen",
		"Alarm_Type": "Alarmtyp:",
		"Warning": "Alarme",
		"Error": "Fehler",
		"Fault": "Erinnerung",
		"Receiving_Report": "Bericht Management",
		"Daily_Report": "Tägliche Berichte",
		"Monthly_Report": "Monatliche Berichte",
		"Yearly_Report": "Jährliche Berichte",
		"Receiving_Plant": "Gepushte Kraftwerke:",
		"E_Mail": "Mailbox：",
		"Email": "Mailbox",
		"Plant": "Verbundene Kraftwerke",
		"Operation": "Betrieb",
		"Alarm_Typetabel": "Alarmtyp",
		"Yes": "Ja",
		"No": "Nein",
		"Delete": "Löschen",
		"suredelete": "ob diesen Mailbox-Push gelöscht werden?",
		"Delete_Mailbox": "Mailbox löschen",
		"Add_suc": "Push-Postfach erfolgreich hinzufügen!",
		"create": "Erstellung",
		"list": "Seriennummer",
		"edit": "Gruppierung bearbeiten"
	},
	"recharge": {
		"cancel": "Abbrechen",
		"early_warning": "Vorauswarnung von Ablauf der Verkehrskarte",
		"orderno": "Nummer der Bestellung",
		"Recharge_tip4": "Empfehlen Sie Benutzern, die sich für PayPal registriert haben, es zu verwenden",
		"recharge_type": "Typ",
		"Recharge_tip3": "Empfohlen für WeChat Benutzer, die es bereits installiert haben",
		"Recharge1": "Aufladen",
		"rechargeStatus": "Status der Aufladung",
		"Recharge_tip5": "WeChat Bezahlen",
		"openWx": "Bitte Mobiltelefon WeChat öffnen",
		"Hint_language": "Ihr Gerät hat ein 2G Gerät. Auf Antrag des Ministeriums für Industrie und Informationstechnologie werden 2G-Netze schrittweise abgebaut. Es wird empfohlen, 4G-Geräte zu kaufen und zu ersetzen!",
		"rechMoney": "Zahlungen",
		"Recharge": "Aufladen",
		"Recharge_tip": "Erinnerung für Aufladen",
		"Dead_Time": "Ablaufzeit",
		"domestic": "inländische",
		"not_for_the_time_being": "momentan nicht in Bearbeitung",
		"Hint_language1": "Bei Problemen während des Aufladevorgangs wenden Sie sich bitte an die Kundendienst-Hotline unter 0755-89993588",
		"rechDiscount": "Ermäßigung",
		"Search": "Suche",
		"warning": "Vorauswarnung",
		"Recharge_tip2": "Bitte wählen Sie z.B.: die gleiche Tragfähigkeit ist 1; Der gleiche Kartentyp ist 4G; Massenaufladung für Festland China Datenkarten in der gleichen Region",
		"Recharge_tip1": "Unterstützt nur Massenaufladung von Karten des gleichen Typs",
		"rechScan": "Bitte öffnen Sie Ihr Mobiltelefon WeChat fegen, um die Zahlung abzuschließen",
		"rechTip": "Erinnerung: 1. Nur Geräte mit demselben Kartentyp (z. B. 4G-Inland), der gleichen Ladekapazität und dem gleichen Plattformstatus zur Armutsbekämpfung können für die gleiche Reihenfolge ausgewählt werden (Standardanzeige zeigt Pakete mit einer Ladekapazität von 1 und nicht mit der Armutsbekämpfungsplattform verbunden). 2. Das Aufladen überfälliger Karten und das Aufladen zwischen 25th und 5th eines jeden Monats führt zu einer Verzögerung von 1-14 Tagen. Bitte haben Sie Geduld und warten Sie",
		"Traffic_status": "Status der Durchflussmenge",
		"Status": "Verkehr Kartenstatus",
		"DataloggerPN": "PN:",
		"Recharge_money": "Betrag der Aufladung",
		"Overdue": "überfällig",
		"Cancel_recharge": "Aufladung abbrechen",
		"Datalogger_List": "Liste der Nummerspicks PN",
		"Recharged": "Erfolgreiches Aufladen",
		"Rcharge_Month": "Monatanzahl der Aufladung",
		"Service_Area": "Servicebereich",
		"Datalogger_PN": "Nummerspicker PN-Nummer",
		"rechargeDevice": "Aufladbares Gerät:",
		"rechargeSucInfo": "Sie haben erfolgreich bezahlt, der Traffic wird innerhalb von 24 Stunden auf Rechnung",
		"Confirm_recharge": "Aufladung bestätigen",
		"scan": "zum Bezahlen schlagen",
		"Paid": "Bezahlt",
		"Time": "Aufladezeit",
		"Unpaid": "Unbezahlt",
		"Operation": "Betrieb",
		"Connecting_Devices": "Bandbreite",
		"Recharge_reminder": "Erinnerung für Aufladen",
		"scanComplete": "Wischen, um die Zahlung abzuschließen",
		"unknown": "Unbekannt",
		"rechargeChannel": "Aufladungmethode:",
		"Signal": "Signalwert",
		"Plant": "Name der Station",
		"rechargeDiscount": "Ermäßiger Betrag:",
		"expired": "Abgelaufen",
		"load": "Bandbreite",
		"Recharge_List": "Gebührenauflistung",
		"ccid": "Verkehr Kartennummer von Nummerspicker",
		"Order_Number": "Nummer der Bestellung",
		"Package_type": "Verpackungstyp",
		"Recharge_record": "Auflade-Protokoll",
		"DataloggerName": "Alias",
		"Recharging": "Aufladung im Gange",
		"Recharge_Selected": "Aufladen",
		"rechargeErr": "Bitte wählen einen Nummerspicker mit der gleichen Ladenummer",
		"rechargePrice": "Betrag der Aufladung:",
		"abroad": "im Ausland",
		"normal": "Normal",
		"previous": "Zurück",
		"CCID": "Nummer der Verkehrskarte",
		"CCID_time": "nach Ablauf der Zeit für Verkehrkarte",
		"serial_number": "Seriennummer",
		"Activation_Time": "Aktivierungszeit",
		"confirm": "Bestätigen",
		"Recharge_status": "Status der Aufladung",
		"Recharge_now": "sofort aufladen",
		"Content_warning": "Lieber Benutzer! gefunden,Ihr Verkehrskarte bald aufgeladen wird.Wenn Sie Ihre Karte nicht rechtzeitig aufladen, wird sie vom Betreiber gesperrt und kann nicht mehr verwendet werden. Um Ihre normale Nutzung nicht zu beeinträchtigen, laden Sie Ihr Gerät bitte rechtzeitig auf!",
		"Recharge_fail": "Aufladen fehlgeschlagen",
		"rechargePackage": "Aufladenspaket:",
		"rechargeSuc": "Erfolgreiche Zahlung",
		"pn": "Nummerspicker PN-Nummer",
		"Tips": "Tipp",
		"Recharge_successful": "Erfolgreiches Aufladen",
		'Recharge_tip6': 'Es gibt Karten, die das Aufladen nicht unterstützen,Bitte wenden Sie sich an den Administrator',
		'area_domestic': 'Chinesisches Festland',
		'area_abroad': 'international',
				'remedy_title': 'Aufladebestellung beheben',
				'upload_tip': 'Freundlicher Hinweis: Das Dateiformat für den Upload ist .txt'
	},
	"customize": {
		"switchSkin": "Skin wechseln",
		"classic": "Rosa",
		"purple": "Lila",
		"blue": "Klassisch Blau",
		"orange": "Süßes Orange",
		"green": "Frisch Grün"
	},
	"firmware": {
		"Firmware_limit_format": "Nur die Dateiformate .bin, .hex und .s19 sind erlaubt",
		"Firmware_upload_fail": "Hochladen fehlgeschlagen, bitte versuchen Sie es erneut!",
		"Firmware_upload_failTip": "Hochladen fehlgeschlagen",
		"Firmware_limit1": "Sie können maximal",
		"Firmware_limit2": "Dateien",
		"Firmware_limit3": "Firmware",
		"Firmware_limitM": "Die Größe der einzelnen Firmware-Datei darf nicht überschreiten",
		"Firmware_Name": "Firmware-Name",
		"Firmware_desrc": "Firmware Darstellung",
		"Size": "Firmware Größe(KB)",
		"Upload_Time": "Upload-Zeit",
		"Operation": "Betrieb",
		"Firmware_List": "Firmware-Verwaltung",
		"Firmware_Lists": "Firmware-Liste",
		"Add_Firmware": "Firmware hinzufügen",
		"deleteFirmware": "Löschen",
		'Firmware_Version': 'Versionsnummer',
		'editFirmware': 'Bearbeiten',
		'downloadFirmware': 'Download',
		"tips": "Tipp",
		"noRecord": "Kein Eintrag",
		"delete_firmware": "diese Firmware gelöscht werden ?",
		"del_firmware": "Firmware löschen",
		"firmware_upgrade": "Firmware aktualisieren",
		"uploadTips": "Bitte die Firmware-Datei hochladen",
		"cancel": "Abbrechen",
		"confirm": "Bestätigung",
		"Upload_firmware": "Firmware upload",
		"Firmware_description": "Firmware Darstellung:",
		"enter_content": "Bitte Inhalt eingeben",
		"Select_file": "Wählen Sie eine Datei",
		"limit": "Es darf nur Dateien im \".bin\"- und \".hex\"-Format hochgeladen werden, und soll nicht größer als 8M sein.",
		"limit0": "Es darf nur Dateien im \".bin\"- und \".hex\",\".S19\"-Format hochgeladen werden, und soll nicht größer als 8M sein.",
		"limit1": "Es darf nur Dateien im \"xlsx\"-Format hochgeladen werden.",
		"limit2": "Hinweis: Die hochgeladene Datei hat eine A-Spalte für PN und eine B-Spalte für Alias, ein Titel ist nicht nötig, Siehe folgende Abbildung.",
		'limit3': 'Erfolgreich hinzugefügt',
		"error1": "Es können nur Dateien im \".bin\" und \".hex\" und \".S19\" Format hochgeladen werden",
        "error2": " Please press LFU button",
		"deleteSuc": "Gelöscht erfolgreich",
		"UploadTitle": "Bitte eine Batch-Datei hochladen",
		"Upload": "Firmware upload",
		"Upload1": "Dateien hochladen",
		"upgrade_quit1": "Upgrade-Ausnahme, abgemeldet!",
		"upgrade_quit2": "Upgrade fehlgeschlagen, bitte versuchen später noch einmal!",
		"upgrade_quit3": "Upgrade erfolgreich",
		"upgrade_quit4": "Upgrade wurde manuell abgebrochen",
		"upgrade_quit5": "Upgrade nicht im Gange",
		"upgrade_quit6": "Upgrade abgebrochen",
		"upgrade_quit7": "Upgrade fehlgeschlagen",
		"upgrade_quit8": "Upgrade-Ausnahme",
		"upgrading": "Upgrade wird durchgeführt",
		"upgrading1": "Upgrade-Verbindung im Gange, bitte warten",
		"updateCompleted": "Upgrade abgeschlossen",
		"CancelUpgradeSuc": "Upgrade erfolgreich abgebrochen",
		"FailedCancelUpgrade": "Upgrade abbrechen fehlgeschlagen",
		"CancelUpgradeSuc11": "Das Upgrade wurde erfolgreich abgebrochen, warten Sie, bis der Datenlogger mit der Cloud verbunden ist",
		"upgrade_wait": "Upgrade wird vorbereitet, bitte 1–2 Minuten warten",
		"upgrade_wait1": "Upgrade-Vorbereitung abgeschlossen. Bitte warten Sie, bis der Datenlogger online ist, und starten Sie die Upgrade-Aufgabe erneut",
		"colOffline": "Datalogger ist offline",
		"colUpgrading": "Bereits im Upgrade-Vorgang",
		"UpgradeStarting": "Upgrade startet, bitte warten...",
		"upgradeSq_fail": "Datalogger-Upgrade fehlgeschlagen, bitte versuchen Sie es später erneut!",
	},
	"browse": {
		'usr': 'Unterkonto',
		'email': 'Postfach',
		'mobile': 'Handy',
		'gts': 'Anmeldedatum',
		'desc': 'Bemerkungen',
		'enableStatus': 'Status aktivieren',
		'Enable': 'aktivieren',
		'Disable': 'Deaktiviert',
		'addBrowse': 'Unterkonto hinzufügen',
		'pleaseUsr': 'Bitte geben Sie ein Unterkonto ein',
		'accountInfo': 'Kontoinformationen',
		'username': 'Benutzername',
		'password': 'Passwort',
		'newPassword': 'Neues Passwort',
		'confirmPassword': 'Passwort bestätigen',
		'usrInfo': 'Benutzerinformationen',
		'device': 'Projektauswahl',
		'pleaseDevice': 'Projekt auswählen',
		'pleaseDevice_title': 'Bitte wählen Sie ein Projekt',
		'pleaseStatus': 'Status auswählen',
		'addSuccess': 'Erfolgreich hinzugefügtes Unterkonto',
		'editSuccess': 'Erfolgreich bearbeitetes Unterkonto',
		'editBrowse': 'Unterkonto bearbeiten',
		'deleteSuccess': 'Erfolgreich gelöscht',
		'deleteBrowse': 'löschen',
		'delete_browse': 'Sind Sie sicher, das Unterkonto zu löschen?',
		'please_browsepwd': 'Bitte überprüfen Sie das neue Passwort und bestätigen Sie die Anforderungen an die Passworteingabe',
	},
	"retrieve": {
		"Retrieve_password": "Passwort abrufen",
		"Retrieve_passwordPhone": "Handy-Passwort abrufen",
		"Retrieve_passwordEmail": "E-Mail-Kennwort abrufen",
		"passwordEmail": "Ungebundene Mailbox",
		"passwordEmail1": "Mailbox überein nicht stimmt",
		"passwordPhone": "Ungebundene Handynummer",
		"passwordPhone1": "Handynummer überein nicht stimmt",
		"login": "Anmeldung",
		"signup": "Registrieren",
		"Enter_account": "Kontonummer eingeben",
		"Verify_identidy": "Identität überprüfen",
		"reset_Password": "Passwort zurücksetzen",
		"finish": "Erledigung",
		"account_password": "Bitte die Kontonummer eingeben, die benötigen, um Passwort abzurufen",
		"username": "Benutzername",
		"Verification_code": "Verifizierungs-Code",
		"phone_number": "Handy-Nummer",
		"new_password": "Neues Anmeldepasswort",
		"Con_password": "das neue Passwort bestätigen",
		"enter_name": "Bitte Benutzernamen eingeben",
		"enter_code": "Bitte geben Sie den Bestätigungscode ein",
		"Change_one": "andere umtauschen",
		"confirm": "Bestätigung",
		"bound_mobile": "Bitte geben gebundene Handynummer ein",
		"Email_verification": "E-Mail-Nachprüfung",
		"Obtain_code": "Prüfcode",
		"code_1minute": "Der Verifizierungscode wurde an Ihr Mobiltelefon gesendet und wird innerhalb 1 Minute gültig sein.",
		"Email": "Mailbox",
		"bound_email": "Bitte E-Mail-Adresse eingeben",
		"Phone_verification": "Überprüfung pür Mobiltelefon",
		"code_5minutes": "Der Verifizierungscode wurde an Ihre E-Mail-Adresse gesendet und gültig innerhalb von 5 Minuten.",
		"New_password": "Neues Anmeldepasswort",
		"Confirm_password": "das neue Passwort bestätigen",
		"Reset_successfully": "Passwort erfolgreich zurückgesetzt, bitte merken Sie sich Ihr neues Passwort",
		"re-register": "Erneut anmelden",
		"Incorrect_code": "Der Verifizierungscode ist nicht richtig",
		"email_first": "Bitte zuerst Ihre E-Mail-Adresse eigeben",
		"mobile_first": "Bitte zuerst Ihre Handynummer eingeben",
		"Reset_passwordSuc": "Passwort zurücksetzen erfolgreich",
		"Get_codeSucc": "Überprüfungscode erfolgreich erhalten",
		"Getting_progress": "In Bearbeitung, bitte warten!",
		"Newloginpassword": "Neues Passwort",
		"Confirmloginpassword": "neues Passwort bestätigen",
		"step1": "Schritt 1",
		"step2": "Schritt 2",
		"step3": "Schritt 3",
		"step4": "Schritt 4"
	},
	"errCode": {
		"0": "Normal, keine Fehler",
		"1": "Fehlgeschlagen",
		"2": "Zeitüberschreitung, System beschäftigt, bitte später erneut versuchen",
		"3": "Systemausnahme, bitte an den Administrator kontaktieren ",
		"4": "Bitte keine Sonderzeichen eingeben (nicht überprüfbare Signatur)",
		"5": "Salzwertfehler, nicht regelkonform verwendet",
		"6": "Falsches Parameterformat",
		"7": "erforderliche Parameter es fehlt",
		"8": "Plattform lehnt ab",
		"9": "Nicht unterstützte Betätigung",
		"10": "keine Beglaubigung, bitte sich erneut anmelden",
		"11": "ohne Erlaubnis Betätigung",
		"12": "Kein Eintrag",
		"13": "die Einschränkung überschreiten",
		"14": "Wiederholte Operation",
		"15": "Herstellerschlüssel nicht gefunden",
		"16": "Passwort Fehler",
		"17": "Falsches Passwortformat",
		"18": "Mobiltelefonnummer ist gebunden, bitte Handynummeränderung oder die Bindung erlösen",
		"19": "Rufnummernformat ist falsch(6<=Zahlenlänge <32)",
		"20": "Mailbox-Format ist falsch (6<=Länge<=64, und einschlisslich @ ) ",
		"21": "Format des Benutzernamens ist falsch (2<=Benutzername Länge <32)",
		"22": "Falsches Format des Firmennamens",
		"23": "Ungültiger Herstellercode, bitte überprüfen, ob der Prüfcode korrekt eingegeben wurde",
		"24": "Benutzername ist abermalig",
		"25": "Das Konto wurde deaktiviert, bitte den Administrator kontaktieren",
		"26": "Die E-Mail wurde gebunden. Bitte ändern Sie die E-Mail oder lösen Sie die Bindung",
		"27": "Das Konto wurde gelöscht, bitte den Administrator kontaktieren",
		"256": "Keine Daten",
		"257": "Kein Nummerspicker",
		"258": "Keine Gräte",
		"259": "Ungültige PN-Nummer, bitte überprüfen Sie, ob die PN-Nummer korrekt ist",
		"260": "Kein Kraftwerk",
		"261": "Kein Benutzer gefunden",
		"262": "Ausrüstung ist offline",
		"263": "Nummerspicker ist offline",
		"264": "Keine Gerätealarme",
		"265": "Kein Umweltprüfgerät",
		"271": "Keine welche Änderungsvorgänge",
		"272": "Wiederholte Bindung",
		"273": "Keine Unterstützung für das Hinzufügen von Nummerspicker aus anderer Hersteller",
		"276": "Keine Unterstützung für den Wechsel von Kraftwerkbesitzern mit Nummerspicker aus anderer Hersteller",
		"288": "Keine Kamera",
		"352": "Keine Firmware",
		"353": "Keine Vereinbarung",
		"368": "Keine Rollen",
		"369": "Keine Gruppierung von Benutzer",
		"370": "Keine Kraftwerksgruppierung",
		"371": "Keine GPRS-Verkehrsaufladepaket",
		"372": "Keine Bestellung für GPRS-Verkehrsaufladung",
		"384": "die Eingabe des Verifizierungscodes ist falsch",
		"385": "Kein device_token",
		"386": "Keine Informationen zur Gerätekonfiguration",
		"387": "Keine Type von Nummerspicker",
		"512": "SMS CAPTCHA-nicht passend",
		"513": "Zeitüberschreitung beim SMS-Verifizierungscode",
		"514": "Telefonsnummer/E-Mail nicht gebunden",
		"515": "Telefonsnummer/Postfach stimmt nicht überein",
		"516": "Name darf nicht der gleiche Name sein",
		"517": "Es gibt auch einen Nummernpicker unter dem Benutzer oder Kraftwerk",
		"518": "Benutzer hat auch untergeordnete Benutzer",
		"519": "Benutzernamen sind verdoppelt ",
		"520": "PN-Nummer ist verdoppelt",
		"521": "Nummerspicker gehört nicht zu dieser Benutzer",
		"522": "Nummerspicker besteht bereits",
		"523": "Kein Viewer-Konto",
		"525": "Der Verifizierungscode wurde gesendet, bitte warten und versuchen erneut",
		"528": "Diese Rolle ist bereits an einen Benutzer gebunden und kann nicht gelöscht werden",
		"768": "Kein optionales Feld bei Vereinbarung",
		"772": "Der Erfassungsgerät ist bereits gebunden",
		"1024": "nur Kraftwerksbesitzer unterstützt",
		"1025": "Nur Administratoren unterstützt",
		"1026": "Nur Gerätehersteller unterstützt",
		"1027": "Der übergeordnete Benutzer benötigt ein Administrator oder Gerätehersteller ",
		"1028": "Nicht unterstützte Aufladungsmethoden",
		"1029": "Verdoppelte Nummerspickernummern",
		"1030": "Ungültige GPRS-Karte",
		"1031": "Benutzer wurde nicht von diesem Administrator erstellt",
		"1041": "Schlüssel ist ungültig oder wurde nicht gefunden",
		"1042": "Ungültige CCID",
		"1792": "Die Nummerspickeren müssen zu alle dem Administrator gehören"
	},
	"controlDeviceErrCode": {
		"1": "Operation fehlgeschlagen, bitte nach überprüfen das Gerät und versuchen es erneut!",
		"2": "Antwortzeitüberschreitung, bitte versuchen es erneut!",
		"3": "Systemausnahme, bitte an den Administrator kontaktieren ",
		"6": "Falsches Format, bitte kontaktieren den Administrator",
		"8": "Abgelehnt, bitte kontaktieren den Administrator",
		"9": "Operation nicht unterstützt, bitte kontaktieren den Administrator",
		"11": "Keine Berechtigung, bitte sich an den Administrator kontaktieren",
		"263": "Der Nummerspicker ist zur Zeit offline, während das Gerät online ist,bitte versuchen erneut!"
	},
	"control":{
		"setting": "Ausstellen",
		"TouSetting": "Systembetriebsmodus",
		"touCharge": "Ladepriorität",
		"touPersonal": "Eigenverbrauch",
		"touComplete": "Volle Einspeisung ins Netz",
		"touClipping": "Lastspitzenkappen und Tal Auffüllen",
		"touOffgrid": "Netzunabhängige Anwendung",
		"confirmModeSwitch": "Moduswechsel bestätigen?",
		"modeSwitch": "Modus wechseln",
		"startTime": "Startzeit",
		"endTime": "Endzeit",
		"paramValue": "Bitte wählen Sie den Parameterwert aus",
		"Monday": "Montag",
		"Tuesday": "Dienstag",
		"Wednesday": "Mittwoch",
		"Thursday": "Donnerstag",
		"Friday": "Freitag",
		"Saturday": "Samstag",
		"Sunday": "Sonntag",
		"syncSetDay": "Synchronisierte Ausstellung täglich",
		"time": "Zeitraum 1",
		"time1": "Zeitraum 2",
		"time2": "Zeitraum 3",
		"time3": "Zeitraum 4",
		"time4": "Zeitraum 5",
		"time5": "Zeitraum 6",
		"setFail": "Ausstellung fehlgeschlagen",
		"readFail": "Lesen fehlgeschlagen",
		"charge": "Aufladen",
		"discharge": "Entladen",
		"reading": "Erfolgreich gelesen",
		"reading_loading": "Wird gelesen...",
		"pvMode": "Netzeinspeisemodus",
		"screenshot": "Screenshot"
	},
	"CollectorCountByOMSOrder": {
		"1": "Operation fehlgeschlagen",
		"7": "Fehlende erforderliche Parameter",
		"8": "Abgelehnt, wenden Sie sich bitte an den Administrator",
		"12": "Es gibt keine gültige Sammler PN-Nummer unter der Bestellung, bitte bestätigen Sie die Bestellnummer",
		"23": "Der Herstellercode ist ungültig. Bitte wenden Sie sich an den Administrator",
		"259": "Es gibt ungültige Collectors unter dieser Bestellung. Bitte kontaktieren Sie den Administrator",
		"261": "Der zugewiesene Distributor kann nicht gefunden werden, wenden Sie sich bitte an den Administrator",
		"772": "Die Bestellung hat bereits einen Sammler gebunden. Bitte bestätigen Sie, dass der Sammler in der Bestellung nicht gebunden ist",
	},
	"message": {
		"uname_is_required": "Konto darf nicht leer sein",
		"id_is_required": "Gruppierung kann nicht leer sein",
		"pwd_is_required": "Das Passwort darf nicht leer sein",
		'confpwd_is_required': 'Passwort bestätigen kann nicht leer sein',
		"invitation_is_required": "Der Erlebenscode soll nicht leer.",
		"pwdAgain": "Bitte geben Sie Ihr Passwort erneut ein",
		"pwdSame": "Altes und neues Passwort dürfen nicht identisch sein",
		"oldPass_wrong": "Das alte Passwort ist falsch, bitte geben es erneut ein",
		"pwdNotsame": "Das Passwort zweimal eingegeben leider nicht identisch ",
		"email_is_required": "Mailbox kann nicht leer sein",
		"email_info": "korrekte E-Mail-Adressen innenhalb 64",
		"mobile_is_required": "Handynummer darf nicht leer sein",
		"pn_is_required": "PN darf nicht leer sein",
		"PN_info": "Die Länge der PN-Nummer beträgt 14- oder 18-stellig, wobei der erste Buchstabe ein Großbuchstabe ist und nur Großbuchstaben und Zahlen enthält",
		"nodata": "Keine Daten",
		"length2_64": "Länge zwischen 2 bis 64 Schriftzeichen",
		"length2_32": "Länge zwischen 2 bis 32 Schriftzeichen",
		"length6_20": "Es kann nur 6 bis 20 Buchstaben, Zahlen und Unterstriche eingegeben ",
		"length6_32": "Länge von 6 bis 32 Schriftzeichen",
		"delete_plant": "Kraftwerk löschen",
		"modify_plant": "Ändern eines Kraftwerks",
		"Exporting_the_report": "Das Konto ist abgemeldet und kann nicht eingeloggt werden",
		"cancel": "Abbrechen",
		"search": "Suche",
		"Logging_off": "Dieses Konto wird gerade abgemeldet und kann nicht eingeloggt werden",
		"country_is_required": "Bitte wählen Sie ein Land oder eine Region",
	},
	"report": {
		"Export_report": "Berichte exportieren",
		"Subscribe_report": "Berichte abonnieren",
		"all_reports": "Alle herleiten",
		"Report_type": "Bericht Typ",
		"Daily_report": "Tägliche Berichte",
		"Monthly_report": "Monatliche Berichte",
		"Yearly_Report": "Jährliche Berichte",
		"Total_report": "Gesamte Report",
		"customize": "Benutzerdefiniert",
		"Report_date": "Reportsdatum:",
		"Report_date1": "Hinweis: Der Bereich der Exportdaten darf nicht 31 Tage überschreiten.",
		"select_date": "Bitte wählen ein Termin",
		"to": "an",
		"start_date": "Startdatum",
		"End_date": "Enddatum",
		"cancel": "Abbrechen",
		"Export": "Exportieren",
		"download": "Download ist im Gange, bitte warten",
		"Batch_export": "Batch-Export",
		"current": "Zu diesem Zeitpunkt",
		"no_deAlarm": "Keine Gerätealarme im letzten Monat",
		"Export_alarm": "Alarme exportieren"
	},
	"collectionFrequencyUP": {
		"collect_fast": "Beschleunigung der Energieflussdaten-Erfassung",
		"collect_fast2": "Energiefluss-Beschleunigung",
		"collect_fast_fail": "Beschleunigung fehlgeschlagen, bitte erneut versuchen",
		"collect_fasting": "Beschleunigen",
		"collect_fast_starting": "Beschleunigung wird gestartet",
		"collect_fast1": "Beschleunigung der detaillierten Datensammlung",
		"collect_fast1ing": "Datenbeschleunigung",
		"paySecCon": "Zahlungsbestätigung",
		"energyFetchPic": "Bestätigung der Aufladung, der Beschleunigungsbereich der Aufladung als Energy Flowchart Seite Parameter wie in der folgenden Abbildung",
		"historyFetchPic": "Bestätigung der Aufladung, der Beschleunigungsbereich der Aufladung als Datendetailseite Parameter wie in der folgenden Abbildung",
		"reRechargeTip1": "Für das aktuelle Gerät wurde bereits der Beschleunigungsdienst für den Energiefluss gekauft. Ein weiterer Kauf verursacht erneut Kosten. Möchten Sie fortfahren?",
		"reRechargeTip": "Für das aktuelle Gerät wurde bereits der Beschleunigungsdienst für die Datendetails gekauft. Ein weiterer Kauf verursacht erneut Kosten. Möchten Sie fortfahren?",
		"continueRecharge": "Weiter aufladen",
		"collect_fasting_title": "Echtzeitparameter werden nicht gespeichert",
		"collect_Order_Record": "Beschleunigte Aufladung",
		"Collection_terms": "Bedingungen für die Beschleunigung der Sammelfrequenz",
		"Recharge_failed_next": "Entschuldigung für das fehlgeschlagene Aufladen, Sie können erneut bezahlen",
		"view_order": "Bestellungen anzeigen",
		"Once": "zweite",
		"every_interval": "Die aktuell ausgewählte Beschleunigungsspezifikation lautet: jedes Intervall",
		"Collect_terms2": "1,1,Umfang der Anwendung der Verpackung",
		"Collect_terms3": "Die Anzeigeparameter, die im Protokoll enthalten sind, das vom Kollektor für Ihre Aufladung verwendet wird (Hinweis: Wenn Sie die Seite Energieflussdiagramm für beschleunigte Aufladung auswählen, ist der Umfang des Pakets auf den Anzeigeparameterbereich der Seite Energieflussdiagramm beschränkt; wenn Sie die Seite Historische Daten für beschleunigte Aufladung auswählen, ist der Umfang des Pakets auf den Anzeigeparameterbereich der Seite Historische Daten begrenzt)",
		"Collect_terms4": "2,Nicht unterstützend Protokoll/Gerätetausch",
		"have_read": "Ich habe es gründlich gelesen",
		"Collect_terms5": "Das Ändern von Protokollen/Geräten trägt nicht zum Beschleunigungspaß bei",
		"Collect_terms6": "3,Abmeldepaket",
		"Collect_terms": "Sammeln von Bedingungen für beschleunigte Aufladung",
		"View_Details": "Details anzeigen",
		"Recharge_result": "Wiederaufladungsergebnis",
		"Collect_terms7": "Abmelden und Änderung nach Zahlung nicht unterstützt",
		"Online_payment": "Online-Zahlung",
		"Collect_terms8": "4,5Paketpreis",
		"Collect_terms9": "Unsere Gebühren werden basierend auf Ihrer Parametermenge, beschleunigter Abholhäufigkeit und Tragfähigkeit berechnet, und der Endpreis wird entsprechend bestimmt; Zusätzlich zu den oben genannten Bedingungen beinhalten historische Daten auch Speicherzeit",
		"acquisition_frequency": "Sammelhäufigkeit",
		"Recharge_failed": "Aufladen fehlgeschlagen",
		"Recharge_amount": "Betrag der Aufladung",
		"Scan_payment": "Zahlung mit Scancode",
		"collect_recharge": "Aufladung der Datensammlungsbeschleunigung (Beschleunigung der detaillierten Datensammlung)",
		"collect_recharge1": "Aufladung der Datensammlungsbeschleunigung (Beschleunigung des Energieflusses)",
		"Collect_terms10": "5,Verkehrsverbrauch",
		"Purchase_Terms7": "Es gibt noch andere Fragen",
		"Purchase_Terms8": "Wenn Sie weitere Fragen haben, können Sie sich gerne an unseren Online-Kundenservice wenden und wir werden Ihnen detaillierte Antworten geben.",
		"Collect_terms11": "Die Beschleunigung der Sammelhäufigkeit erhöht den Verkehrsverbrauch",
		"Purchase_Terms6": "Unsere Gebühren werden basierend auf Ihrer Parametermenge, beschleunigter Abholhäufigkeit und Tragfähigkeit berechnet, und der Endpreis wird entsprechend bestimmt; Zusätzlich zu den oben genannten Bedingungen beinhalten historische Daten auch Speicherzeit",
		"Purchase_Terms5": "Pauschalpreis",
		"Purchase_Terms4": "Bitte freuen Sie sich auf unsere neue Version. Die aktuelle Version unterstützt nur das Sammeln und Aktualisieren aller Anzeigeparameter. Wir entschuldigen uns für eventuelle Unannehmlichkeiten!",
		"Purchase_Terms3": "Kann ich das Upgrade der Sammelfrequenz für einige Parameter nicht anpassen",
		"Real_parameters": "Echtzeit-Parameter",
		"Purchase_Terms1": "Gültigkeitsdauer der Erfassungsbeschleunigung",
		"Purchase_Terms2": "Die Ablaufzeit des Erfassungsbeschleunigungsdienstes wird automatisch anhand der von Ihnen erworbenen Paketdauer berechnet. Die genaue Ablaufzeit richtet sich nach der Seitenanzeige",
		"device_Info": "Geräte-Informationen",
		"Recharge_successful_next": "Wir gratulieren Ihnen zu Ihrer erfolgreichen Wiederaufladung. Wir sind dabei, Ihre Abholhäufigkeit zu aktualisieren, und Sie können die Änderungen Ihrer Abholhäufigkeit von nun an verfolgen.",
		"Purchase_Terms": "Einkaufsbedingungen",
		"gather": "Sammlung",
		"Recharge_time": "Aufladezeit",
		"Payment_method": "Zahlungsmethode",
		"Type": "Aufladungstyp",
		"Recharge_now": "sofort aufladen",
		"History_Data": "historische Daten",
		"Collect_terms1": "Servicebedingungen für Beschleunigung der Sammelhäufigkeit",
		"Package": "Beschleunigungspaket",
		"PN_order": "PN/Bestellnummer",
		"Order_No": "Nummer der Bestellung",
		"Recharge_successful": "Erfolgreiches Aufladen",
		"noRecharg": "Der Kollektor unterstützt das Aufladen nicht",
		"noRecharg_min": "Ihre Sammelgeschwindigkeit ist am schnellsten!",
		"noRecharg_wifi": "Die aktuelle Version unterstützt nur die Datenerfassung von WLAN-Modulen",
		"paypalTip": "Der endgültige Zahlungsbetrag basiert auf PayPal",
		"upPrice": "Preisunterschied",
	},
	alarmNew: {
		'fileName': 'Dateiname',
		'fileSize': 'Dateigröße',
		'fileStatus': 'Dateistatus',
		'progress': 'Fortschritt',
		'can': 'Herunterladbar',
		'no': 'Wird exportiert',
		'history': 'Exportverlauf'
	},
	shuoriExport:{
        "exportRecords": "Exportaufzeichnungen",
        "export": "Exportieren",
        "exportTask": "Exportaufgabe wurde erstellt. Bitte laden Sie die Datei später unter „Exportaufzeichnungen“ herunter.",
        "noDownload": "Die Datei-URL ist ungültig oder kann nicht heruntergeladen werden. Bitte versuchen Sie es erneut.",
		'data': 'Datum',
	},
	colUnBindRecord: {
	'UnBindRecord': 'Entbindungsprotokoll des Datenloggers',
    "unStatus": "Entbindungsstatus",
    "unScene": "Entbindungs-Szenario",
    "oldUser": "Ursprünglicher Benutzer",
    "newUser": "Neuer Benutzer",
    "unCount": "Anzahl der Entbindungen",
    "pnBarCode": "PN-Barcode",
    "devicePicture": "Foto des physischen Geräts",
    "ip": "Freigegebene IP",
    "unTime": "Entbindungszeitpunkt"
	},
	rosRecharge: {
		'electronicInvoicing': 'Elektronische Rechnungsstellung',
		'issueEInvoice': 'E-Rechnung ausstellen',
		'invoiceHistory': 'Rechnungsverlauf',
		'rechargeDuration': 'Aufladedauer',
		'year': 'Jahr',
		'month': 'Monat',
		'day': 'Tag',
		'days': 'Tage',
		'pendingPayment': 'Zahlung ausstehend',
		'paymentSuccess': 'Zahlung erfolgreich',
		'paymentFailed': 'Zahlung fehlgeschlagen',
		'orderClosed': 'Bestellung geschlossen',
		'serviceTerminated': 'Dienst beendet',
		'unpaid': 'Nicht bezahlt',
		'paying': 'Zahlung läuft',
		'paid': 'Bezahlt',
		'refunded': 'Erstattet',
		'cancelled': 'Storniert',
		'rechargeSuccess': 'Aufladung erfolgreich',
		'rechargeFailed': 'Aufladung fehlgeschlagen',
		'pleaseSelectDate': 'Bitte Datum auswählen',
		'orderNo': 'Bestellnummer',
		'batchInvoicing': 'Sammelrechnung',
		'rechargeType': 'Aufladeart',
		'trafficRecharge': 'Datenaufladung',
		'collectRecharge': 'Erfassungsaufladung',
		'rechargeStatus': 'Aufladestatus',
		'invoice': 'Rechnung',
		'invoiceStatus': 'Rechnungsstatus',
		'invoiceTime': 'Rechnungszeitpunkt',
		'viewDetail': 'Details ansehen',
		'invoicing': 'Rechnung wird erstellt',
		'invoiceSuccess': 'Rechnung erfolgreich erstellt',
		'invoiceFailed': 'Rechnungserstellung fehlgeschlagen',
		'issueElectronicInvoice': 'E-Rechnung ausstellen',
		'invoiceType': 'Rechnungsart',
		'generalInvoice': 'Normale Rechnung',
		'specialInvoice': 'Spezialrechnung',
		'headerType': 'Kopfzeilentyp',
		'companyHeader': 'Unternehmenskopfzeile',
		'personalHeader': 'Persönlich/Nicht-Unternehmen',
		'pleaseInputCompanyHeader': 'Bitte Unternehmenskopfzeile eingeben',
		'taxNumber': 'Steuernummer des Unternehmens',
		'pleaseInputTaxNumber': 'Bitte Steuerpflichtige-Identifikationsnummer eingeben',
		'headerName': 'Kopfzeilenname',
		'suggestPersonalName': 'Empfehlung: Persönlicher Name / Geschäftsname',
		'invoiceContent': 'Rechnungsinhalt',
		'internetCommService': 'Internet-Kommunikationsdienste',
		'invoiceAmount': 'Rechnungsbetrag',
		'yuan': 'Yuan',
		'moreInfo': 'Weitere Informationen',
		'remarkAddressEtc': 'Bemerkung, Adresse usw.',
		'companyAddress': 'Unternehmensadresse',
		'pleaseInputCompanyAddress': 'Bitte Unternehmensadresse eingeben',
		'companyPhone': 'Unternehmenstelefon',
		'pleaseInputCompanyPhone': 'Bitte Unternehmenstelefon eingeben',
		'openingBank': 'Kontoführende Bank',
		'pleaseInputOpeningBank': 'Bitte kontoführende Bank eingeben',
		'bankAccount': 'Bankkontonummer',
		'pleaseInputBankAccount': 'Bitte Bankkontonummer eingeben',
		'remark': 'Bemerkung',
		'pleaseInputRemark': 'Bitte Bemerkung eingeben',
		'email': 'E-Mail-Adresse',
		'pleaseInputEmail': 'Bitte E-Mail-Adresse eingeben',
		'cancel': 'Abbrechen',
		'submit': 'Einreichen',
		'invoiceResult': 'Rechnungsergebnis',
		'invoiceSubmitted': 'Rechnungsantrag wurde eingereicht',
		'invoiceExpectedTip': 'Die Rechnung wird voraussichtlich innerhalb von 48 Stunden ausgestellt. Bitte beachten Sie den Eingang.',
		'viewInvoiceStatus': 'Rechnungsstatus ansehen',
		'pleaseInputHeaderName': 'Bitte Kopfzeilennamen eingeben',
		'pleaseInputValidEmail': 'Bitte korrekte E-Mail-Adresse eingeben',
		'invoiceApplyFailed': 'Rechnungsantrag fehlgeschlagen',
		'viewInvoice': 'Rechnung ansehen',
		'downloadPdf': 'PDF-Datei herunterladen',
		'manualService': 'Kundendienst',
		'invoiceSentToEmail': 'Die Rechnungsinformationen wurden per E-Mail gesendet. Bitte beachten Sie den Eingang.',
		'pleaseWaitInvoicing': 'Bitte warten Sie geduldig auf die Fertigstellung der Rechnung',
		'pleaseContactManual': 'Bitte wenden Sie sich an den Kundendienst für die Rechnungsstellung',
		'noPdfAvailable': 'Keine herunterladbare PDF-Datei verfügbar',
		'serviceUnavailable': 'Kundendienstfunktion vorübergehend nicht verfügbar',

	}
}
export default de;